webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _vue = __webpack_require__(23);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueTranslatePlugin = __webpack_require__(177);
	
	var _vueTranslatePlugin2 = _interopRequireDefault(_vueTranslatePlugin);
	
	var _axios = __webpack_require__(51);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vueAxios = __webpack_require__(146);
	
	var _vueAxios2 = _interopRequireDefault(_vueAxios);
	
	var _vueWysiwyg = __webpack_require__(178);
	
	var _vueWysiwyg2 = _interopRequireDefault(_vueWysiwyg);
	
	var _vueSelect = __webpack_require__(176);
	
	var _vueSelect2 = _interopRequireDefault(_vueSelect);
	
	var _store = __webpack_require__(32);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(84);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _App = __webpack_require__(147);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component("v-select", _vueSelect2.default);
	_vue2.default.use(_vueAxios2.default, _axios2.default);
	_vue2.default.use(_vueWysiwyg2.default, {
	  hideModules: {
	    justifyLeft: true,
	    justifyCenter: true,
	    justifyRight: true,
	    link: true,
	    code: true,
	    orderedList: true,
	    unorderedList: true,
	    image: true,
	    table: true,
	    removeFormat: true,
	    separator: true
	  },
	  forcePlainTextOnPaste: true
	});
	_vue2.default.use(_vueTranslatePlugin2.default);
	
	window.$ = window.jQuery = __webpack_require__(143);
	__webpack_require__(93);
	
	new _vue2.default({
	  router: _router2.default,
	  store: _store2.default,
	  el: "#app",
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reviewDAO = exports.articleDAO = exports.status = exports.PUBLISHED_STATUS = exports.REFUSED_STATUS = exports.UNDER_REFEREE_STATUS = exports.AWAITING_REVIEW_STATUS = exports.SUBMITTED_STATUS = exports.NEEDS_CORRECTIONS_STATUS = exports.DELETED_STATUS = undefined;
	
	var _extends6 = __webpack_require__(91);
	
	var _extends7 = _interopRequireDefault(_extends6);
	
	var _defineProperty2 = __webpack_require__(90);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _allStatus;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DELETED_STATUS = exports.DELETED_STATUS = 0;
	var NEEDS_CORRECTIONS_STATUS = exports.NEEDS_CORRECTIONS_STATUS = 5;
	var SUBMITTED_STATUS = exports.SUBMITTED_STATUS = 10;
	var AWAITING_REVIEW_STATUS = exports.AWAITING_REVIEW_STATUS = 20;
	var UNDER_REFEREE_STATUS = exports.UNDER_REFEREE_STATUS = 30;
	var REFUSED_STATUS = exports.REFUSED_STATUS = 40;
	var PUBLISHED_STATUS = exports.PUBLISHED_STATUS = 50;
	
	var allStatus = (_allStatus = {}, (0, _defineProperty3.default)(_allStatus, DELETED_STATUS, "Deleted"), (0, _defineProperty3.default)(_allStatus, NEEDS_CORRECTIONS_STATUS, "Needs Corrections"), (0, _defineProperty3.default)(_allStatus, SUBMITTED_STATUS, "Submitted"), (0, _defineProperty3.default)(_allStatus, AWAITING_REVIEW_STATUS, "Awaiting Review"), (0, _defineProperty3.default)(_allStatus, UNDER_REFEREE_STATUS, "Reviewed"), (0, _defineProperty3.default)(_allStatus, REFUSED_STATUS, "Refused"), (0, _defineProperty3.default)(_allStatus, PUBLISHED_STATUS, "Published"), _allStatus);
	
	var status = exports.status = {
	  god: [DELETED_STATUS, NEEDS_CORRECTIONS_STATUS, SUBMITTED_STATUS, AWAITING_REVIEW_STATUS, UNDER_REFEREE_STATUS, REFUSED_STATUS, PUBLISHED_STATUS].reduce(function (obj, cur) {
	    return (0, _extends7.default)({}, obj, (0, _defineProperty3.default)({}, cur, allStatus[cur]));
	  }, {}),
	  admin: [NEEDS_CORRECTIONS_STATUS, SUBMITTED_STATUS, AWAITING_REVIEW_STATUS, UNDER_REFEREE_STATUS, REFUSED_STATUS, PUBLISHED_STATUS].reduce(function (obj, cur) {
	    return (0, _extends7.default)({}, obj, (0, _defineProperty3.default)({}, cur, allStatus[cur]));
	  }, {}),
	  reviewer: [AWAITING_REVIEW_STATUS, UNDER_REFEREE_STATUS].reduce(function (obj, cur) {
	    return (0, _extends7.default)({}, obj, (0, _defineProperty3.default)({}, cur, allStatus[cur]));
	  }, {}),
	  author: [NEEDS_CORRECTIONS_STATUS, SUBMITTED_STATUS, AWAITING_REVIEW_STATUS, UNDER_REFEREE_STATUS, REFUSED_STATUS, PUBLISHED_STATUS].reduce(function (obj, cur) {
	    return (0, _extends7.default)({}, obj, (0, _defineProperty3.default)({}, cur, allStatus[cur]));
	  }, {})
	};
	
	var articleDAO = exports.articleDAO = function articleDAO() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    title: input.title || "",
	    term: input.term_org || "",
	    author: input.author_surname + ", " + input.author_name || "",
	    status: allStatus["" + input.status] || "",
	    date: input.updated_at.split(" ")[0] || "",
	    viewLink: "/article/" + input.id || "",
	    reviewLink: "/article/" + input.id + "/review" || "",
	    editLink: "/article/" + input.id + "/edit" || ""
	  };
	};
	
	var reviewDAO = exports.reviewDAO = function reviewDAO() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return {
	    text: input.text || "",
	    approved: input.approved || 0,
	    corrections: input.corrections || 1,
	    article_id: input.article_id || 0,
	    user_id: input.user_id || 0
	  };
	};

/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(139)
	
	/* script */
	__vue_exports__ = __webpack_require__(69)
	
	/* template */
	var __vue_template__ = __webpack_require__(170)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(23);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(182);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexPersist = __webpack_require__(180);
	
	var _vuexPersist2 = _interopRequireDefault(_vuexPersist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var vuexLocalStorage = new _vuexPersist2.default({
	  key: "aen",
	  storage: window.localStorage });
	
	var state = {
	  appTitle: "aen",
	  appVersion: "0.0.1",
	  auth: {
	    token: "",
	    expires: 0,
	    role: ""
	  }
	};
	
	var getters = {
	  isLoggedIn: function isLoggedIn(state) {
	    return state.auth.token && state.auth.expires > Date.now();
	  },
	  role: function role(state) {
	    return state.auth.role;
	  }
	};
	
	var mutations = {
	  login: function login(state, _ref) {
	    var token = _ref.token,
	        expires = _ref.expires,
	        role = _ref.role;
	
	    state.auth.token = token;
	    state.auth.expires = expires;
	    state.auth.role = role || "author";
	  },
	  logout: function logout(state) {
	    state.auth.token = "";
	    state.auth.expires = 0;
	    state.auth.role = "";
	  }
	};
	
	var actions = {
	  login: function login(_ref2, payload) {
	    var commit = _ref2.commit;
	
	    commit("login", payload);
	  },
	  logout: function logout(_ref3) {
	    var commit = _ref3.commit;
	
	    commit("logout");
	  }
	};
	
	var store = new _vuex2.default.Store({
	  state: state,
	  getters: getters,
	  mutations: mutations,
	  actions: actions,
	  plugins: [vuexLocalStorage.plugin]
	});
	
	exports.default = store;

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(75)
	
	/* template */
	var __vue_template__ = __webpack_require__(165)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(77)
	
	/* template */
	var __vue_template__ = __webpack_require__(172)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(132)
	
	/* script */
	__vue_exports__ = __webpack_require__(78)
	
	/* template */
	var __vue_template__ = __webpack_require__(162)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Navbar = __webpack_require__(153);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _LinkBlock = __webpack_require__(152);
	
	var _LinkBlock2 = _interopRequireDefault(_LinkBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: { Navbar: _Navbar2.default, LinkBlock: _LinkBlock2.default }
	};

/***/ }),
/* 69 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "Article",
	  props: {
	    article: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    term: {
	      type: String,
	      default: ""
	    },
	    showAuthor: {
	      type: Boolean,
	      default: true
	    }
	  }
	};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Article = __webpack_require__(22);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _helpers = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ArticlePage",
	  components: { Article: _Article2.default },
	  computed: {
	    role: function role() {
	      return this.$store.getters.role;
	    },
	    showAuthor: function showAuthor() {
	      return this.article.status === _helpers.PUBLISHED_STATUS || this.$store.getters.role !== "reviewer";
	    }
	  },
	  data: function data() {
	    return {
	      article: {},
	      term: ""
	    };
	  },
	  mounted: function mounted() {
	    var app = this;
	    app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/articles/" + app.$route.params.id).then(function (response) {
	      app.article = response.data;
	      app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/terms/" + app.article.term_id).then(function (response2) {
	        app.term = response2.data.term_english;
	      });
	    });
	  }
	};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(86);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _Article = __webpack_require__(22);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "EditPage",
	  components: { Article: _Article2.default },
	  data: function data() {
	    return {
	      loadedArticle: {},
	      showForm: this.$store.getters.isLoggedIn,
	      apiTerms: "",
	      apiLanguages: "",
	      apiLexicalUnits: "",
	      entry: {
	        id: "",
	        lexical: false,
	        new: false,
	        english: "",
	        section: ""
	      },
	      article: {
	        name_language: "",
	        title: "",
	        body: "",
	        img_url: "",
	        img_auth: true,
	        keyword1: "",
	        keyword2: "",
	        keyword3: "",
	        currentLink: "",
	        linkList: [],
	        linkValidation: false,
	        author: {
	          surname: "",
	          firstName: "",
	          affiliation: "",
	          mail: true
	        },
	        references: "",
	        status: 10
	      },
	      definition: {
	        id: "",
	        langOriginSelected: "",
	        origin: "",
	        occurrence: "",
	        lang_orig_id: 0,
	        lang_occu_id: 0,
	        category: 0,
	        meaning: "",
	        synonyms: "",
	        notes: "",
	        author: {
	          surname: "",
	          firstName: "",
	          affiliation: "",
	          mail: true
	        },
	        references: ""
	      },
	      copyright: true,
	      validation: "",
	      review: {},
	      term: ""
	    };
	  },
	
	  computed: {
	    articleId: function articleId() {
	      return parseInt(this.$route.params.id, 10);
	    },
	    isLoggedIn: function isLoggedIn() {
	      return this.$store.getters.isLoggedIn;
	    }
	  },
	  methods: {
	    showFormChange: function showFormChange() {
	      this.showForm = true;
	    },
	    langSelect: function langSelect(value) {
	      var app = this;
	      app.definition.langOriginSelected = value;
	      app.definition.lang_orig_id = 0;
	    },
	    selectListLexical: function selectListLexical() {
	      var app = this;
	      if (typeof app.entry.id === "string") {
	        app.entry.lexical = true;
	        var lexId = app.entry.id.replace("lu-", "");
	        app.definition.id = parseInt(lexId, 10);
	        app.lexicalPlaceholder();
	      } else {
	        app.entry.lexical = false;
	      }
	    },
	    lexicalPlaceholder: function lexicalPlaceholder() {
	      var app = this;
	      app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/lexicalunits/" + app.definition.id).then(function (response) {
	        var lexical = response.data;
	        app.definition.english = lexical.term_english;
	        app.definition.article = lexical.term_article;
	        app.definition.origin = lexical.term_orig;
	        app.definition.occurrence = lexical.term_occu;
	        app.definition.lang_orig_id = lexical.lang_orig_id;
	        app.definition.lang_occu_id = lexical.lang_occu_id;
	        app.definition.meaning = lexical.meaning;
	        app.definition.synonyms = lexical.synonyms;
	        app.definition.notes = lexical.notes;
	        app.definition.category = lexical.gramcategory_id;
	        app.definition.author.firstName = lexical.author_name;
	        app.definition.author.surname = lexical.author_surname;
	        app.definition.author.affiliation = lexical.author_affiliation;
	        app.definition.references = lexical.references;
	      });
	    },
	    uploadImage: function uploadImage() {
	      var app = this;
	      var formData = new FormData();
	      formData.append("imageFile", event.target.files[0]);
	      var token = this.$store.state.auth.token;
	      if (token) {
	        var config = {
	          headers: {
	            Authorization: "Bearer " + token,
	            "content-type": "multipart/form-data"
	          }
	        };
	        this.axios.post(("http://aen-api.fcsh.unl.pt/api/web") + "/images", formData, config).then(function (response) {
	          app.article.img_url = response.data.imageFile;
	        });
	      }
	    },
	    addLink: function addLink(value) {
	      var app = this;
	      if (app.article.linkList.length < 3) {
	        app.article.linkValidation = false;
	        app.article.linkList.push(value);
	      } else {
	        app.article.linkValidation = true;
	      }
	    },
	    removeLink: function removeLink(value) {
	      var app = this;
	      app.article.linkList.pop(value);
	      app.article.linkValidation = false;
	    },
	    validateArticle: function validateArticle() {
	      var app = this;
	      if (app.article.body === "") {
	        app.validation = "Article body field is empty";
	      } else if (app.article.img_url && !app.article.img_auth) {
	        app.validation = "Missing Creative Commons License declaration on image upload";
	      } else if (app.article.references === "") {
	        app.validation = "Bibliographic references is empty";
	      } else if (app.article.author.firstName === "") {
	        app.validation = "Author First Name is empty";
	      } else if (app.article.author.surname === "") {
	        app.validation = "Author Surname is empty";
	      } else if (app.copyright === "false") {
	        app.validation = "You must agree with the Terms of Use and Copyright of the Afro-European Cartography of Culture Language and Arts.";
	      } else {
	        app.submitArticle();
	      }
	    },
	    submitArticle: function submitArticle() {
	      var app = this;
	      var token = this.$store.state.auth.token;
	      if (token) {
	        var config = {
	          headers: { Authorization: "Bearer " + token }
	        };
	        this.axios.patch(("http://aen-api.fcsh.unl.pt/api/web") + '/articles/' + app.loadedArticle.id, {
	          title: app.article.title,
	          term_org: app.article.name_language,
	          text: app.article.body,
	
	          author_name: app.article.author.firstName,
	          author_surname: app.article.author.surname,
	          author_affiliation: app.article.author.affiliation,
	          author_pub_auth: true,
	          img_url: app.article.img_url,
	          references: this.article.references,
	          keywords: [app.article.keyword1, app.article.keyword2, app.article.keyword3],
	          links: app.article.linkList,
	          status: app.article.status
	        }, config).then(function (response) {
	          app.validation = response.data;
	          app.$router.push("/article/" + app.loadedArticle.id);
	        }).catch(function (error) {
	          app.validation = error;
	        });
	      }
	    },
	    deleteArticle: function deleteArticle() {
	      var app = this;
	      var token = this.$store.state.auth.token;
	      if (token) {
	        var config = {
	          headers: { Authorization: "Bearer " + token }
	        };
	        this.axios.patch(("http://aen-api.fcsh.unl.pt/api/web") + '/articles/' + app.loadedArticle.id, {
	          status: 0
	        }, config).then(function (response) {
	          app.validation = response.data;
	          app.$router.push("/submissions/");
	        }).catch(function (error) {
	          app.validation = error;
	        });
	      }
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    var app = this;
	    app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/terms").then(function (response) {
	      app.apiTerms = response.data;
	    });
	    app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/languages").then(function (response) {
	      app.apiLanguages = response.data;
	    });
	    app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/gramcategories").then(function (response) {
	      app.apiGramCategories = response.data;
	    });
	    app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/lexicalunits").then(function (response) {
	      app.apiLexicalUnits = response.data;
	    });
	
	    this.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + ("/articles/" + this.articleId), {
	      headers: {
	        Authorization: "Bearer " + this.$store.state.auth.token
	      }
	    }).then(function (response) {
	      _this.loadedArticle = response.data;
	      _this.article.title = response.data.title;
	      _this.article.status = response.data.status < 10 ? 10 : response.data.status;
	      _this.article.name_language = response.data.term_org;
	      _this.article.body = response.data.text;
	      _this.article.keyword1 = response.data.keywords[0].keyword;
	      _this.article.keyword2 = response.data.keywords[1].keyword;
	      _this.article.keyword3 = response.data.keywords[2].keyword;
	      _this.article.references = response.data.references;
	      _this.article.author.firstName = response.data.author_name;
	      _this.article.author.surname = response.data.author_surname;
	      _this.article.author.affiliation = response.data.author_affiliation;
	      var x;
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(response.data.links), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          x = _step.value;
	
	          app.article.linkList.push(x.id);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      _this.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + ("/terms/" + _this.article.term_id)).then(function (response) {
	        _this.term = response.data;
	      });
	    });
	  }
	};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _helpers = __webpack_require__(11);
	
	exports.default = {
	  data: function data() {
	    return {
	      searcher: "",
	      apiLanguages: "",
	      authorSearcher: "",
	      articleList: "",
	      termList: [],
	      lexicalList: [],
	      sectionList: "",
	      showText: false,
	      topFilter: "az",
	      azFilter: "a",
	      themFilter: "",
	      themAzFilter: "a",
	      subThemFilter: "general",
	      alphabet: ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"],
	      browse: true,
	      langSource: "0",
	      langTarget: "0"
	    };
	  },
	
	  computed: {},
	  mounted: function mounted() {
	    var app = this;
	    app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/articles?filters[status]=[" + _helpers.PUBLISHED_STATUS + "]").then(function (response) {
	      app.articleList = response.data;
	    });
	    app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/lexicalunits").then(function (response) {
	      app.lexicalList = response.data;
	    });
	    app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/terms").then(function (response) {
	      app.termList = response.data;
	    });
	    app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/sections").then(function (response) {
	      app.sectionList = response.data;
	    });
	    app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/languages").then(function (response) {
	      app.apiLanguages = response.data;
	    });
	  },
	
	  methods: {
	    setAzFilter: function setAzFilter(value) {
	      this.azFilter = value;
	      console.log(value);
	    },
	    setThemAzFilter: function setThemAzFilter(value) {
	      this.themAzFilter = value;
	      console.log(value);
	    },
	    filterByAuthor: function filterByAuthor(author) {},
	    filteredTerms: function filteredTerms(letter) {
	      var terms = this.termList;
	      if (letter) {
	        terms = terms.filter(function (name) {
	          var firstLetter = name.term_english.charAt(0).toLowerCase();
	          return firstLetter === letter;
	        });
	      }
	      return terms;
	    },
	    filteredUnits: function filteredUnits(letter) {
	      var terms = this.lexicalList;
	      if (letter) {
	        terms = terms.filter(function (name) {
	          var firstLetter = name.term_english.charAt(0).toLowerCase();
	          return firstLetter === letter;
	        });
	      }
	      return terms;
	    }
	  }
	};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {
	            lexical: '',
	            term: '',
	            apiGramCategories: '',
	            apiLanguages: ""
	        };
	    },
	    mounted: function mounted() {
	        var app = this;
	        app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + '/lexicalunits/' + app.$route.params.id).then(function (response) {
	            app.lexical = response.data;
	        });
	        app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/gramcategories").then(function (response) {
	            app.apiGramCategories = response.data;
	        });
	        app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/languages").then(function (response) {
	            app.apiLanguages = response.data;
	        });
	    }
	};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "LinkBlock",
	  computed: {
	    isLoggedIn: function isLoggedIn() {
	      return this.$store.getters.isLoggedIn;
	    },
	    role: function role() {
	      return this.$store.getters.role;
	    }
	  },
	  methods: {
	    logout: function logout() {
	      this.$router.push("/");
	      this.$store.dispatch("logout");
	    }
	  }
	};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "Login",
	  data: function data() {
	    return {
	      login: {
	        username: "",
	        email: "",
	        password: ""
	      },
	      loginValidation: ""
	    };
	  },
	
	  methods: {
	    validateLogin: function validateLogin(value) {
	      var _this = this;
	
	      this.login.username = this.login.email;
	      this.axios.post(("http://aen-api.fcsh.unl.pt/api/web") + "/login", this.login).then(function (response) {
	        if (response.data.error) {
	          console.error(response.data.error);
	          _this.loginValidation = response.data.error;
	        } else {
	          _this.$store.dispatch("login", response.data).then(function () {
	            var redirectPath = _this.$route.query.redirect;
	            if (redirectPath) {
	              _this.$router.push(redirectPath);
	            } else {
	              _this.$emit("showFormChanged");
	            }
	          });
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 76 */
/***/ (function(module, exports) {

	"use strict";

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "Register",
	  data: function data() {
	    return {
	      register: {
	        username: '',
	        email: '',
	        password: ''
	      },
	      registerValidation: ''
	    };
	  },
	
	  methods: {
	    validateRegister: function validateRegister(value) {
	      var _this = this;
	
	      this.register.username = this.register.email;
	      this.axios.post(("http://aen-api.fcsh.unl.pt/api/web") + '/register', this.register).then(function (response) {
	        if (response.data.error) {
	          console.error(response.data.error);
	          _this.registerValidation = response.data.error;
	        } else {
	          _this.$store.dispatch("login", response.data).then(function () {
	            _this.$emit("showFormChanged");
	          });
	        }
	      });
	    }
	  }
	};

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "ReviewForm",
	  props: {
	    review: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    disabled: {
	      type: Boolean,
	      default: false
	    }
	  }
	};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(92);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _vueFragment = __webpack_require__(47);
	
	var _Article = __webpack_require__(22);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _ReviewersForm = __webpack_require__(155);
	
	var _ReviewersForm2 = _interopRequireDefault(_ReviewersForm);
	
	var _ReviewForm = __webpack_require__(50);
	
	var _ReviewForm2 = _interopRequireDefault(_ReviewForm);
	
	var _helpers = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ReviewPage",
	  components: { Fragment: _vueFragment.Fragment, Article: _Article2.default, ReviewersForm: _ReviewersForm2.default, ReviewForm: _ReviewForm2.default },
	  data: function data() {
	    return {
	      article: {},
	      reviews: [{}, {}],
	      reviewers: [],
	      term: "",
	      status: 10
	    };
	  },
	
	  computed: {
	    articleId: function articleId() {
	      return parseInt(this.$route.params.id, 10);
	    },
	    isLoggedIn: function isLoggedIn() {
	      return this.$store.getters.isLoggedIn;
	    },
	    role: function role() {
	      return this.$store.getters.role;
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (["god", "admin"].includes(this.role)) {
	      this.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/reviewers", {
	        headers: {
	          Authorization: "Bearer " + this.$store.state.auth.token
	        }
	      }).then(function (response) {
	        _this.reviewers = response.data;
	      });
	    }
	    this.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/reviews/user", {
	      headers: {
	        Authorization: "Bearer " + this.$store.state.auth.token
	      }
	    }).then(function (response) {
	      var reviews = response.data.filter(function (review) {
	        return review.article_id === _this.articleId;
	      });
	      _this.reviews = [].concat((0, _toConsumableArray3.default)(new Array(2))).map(function (_item, idx) {
	        return reviews[idx] ? reviews[idx] : (0, _helpers.reviewDAO)({
	          article_id: _this.articleId
	        });
	      });
	    });
	    this.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + ("/articles/" + this.articleId), {
	      headers: {
	        Authorization: "Bearer " + this.$store.state.auth.token
	      }
	    }).then(function (response) {
	      _this.article = response.data;
	      _this.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + ("/terms/" + _this.article.term_id)).then(function (response) {
	        _this.term = response.data.term_english;
	      });
	    });
	  },
	
	  methods: {
	    submitReview: function submitReview(review) {
	      var _this2 = this;
	
	      this.axios.patch(("http://aen-api.fcsh.unl.pt/api/web") + ("/reviews/" + review.id), review, {
	        headers: {
	          Authorization: "Bearer " + this.$store.state.auth.token
	        }
	      }).then(function (_response) {
	        _this2.$router.push("/submissions");
	      });
	    },
	    submitReviews: function submitReviews() {
	      var _this3 = this;
	
	      this.reviews.forEach(function (review) {
	        if (review.user_id > 0) {
	          if (review.id) {
	            _this3.axios.patch(("http://aen-api.fcsh.unl.pt/api/web") + ("/reviews/" + review.id), review, {
	              headers: {
	                Authorization: "Bearer " + _this3.$store.state.auth.token
	              }
	            }).then(function (_response) {
	              _this3.$router.push("/submissions");
	            });
	          } else {
	            _this3.axios.post(("http://aen-api.fcsh.unl.pt/api/web") + "/reviews", review, {
	              headers: {
	                Authorization: "Bearer " + _this3.$store.state.auth.token
	              }
	            }).then(function (_response) {
	              _this3.$router.push("/submissions");
	            });
	          }
	        } else {
	          _this3.$router.push("/submissions");
	        }
	      });
	    },
	
	    updateStatus: function updateStatus() {
	      this.axios.patch(("http://aen-api.fcsh.unl.pt/api/web") + '/articles/' + this.articleId, {
	        status: Number(this.status)
	      }, {
	        headers: {
	          Authorization: "Bearer " + this.$store.state.auth.token
	        }
	      }).then(function (response) {
	        this.validation = response.data;
	      }).catch(function (error) {
	        this.validation = error;
	      });
	    }
	  }
	};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueFragment = __webpack_require__(47);
	
	var _vueFragment2 = _interopRequireDefault(_vueFragment);
	
	var _ReviewForm = __webpack_require__(50);
	
	var _ReviewForm2 = _interopRequireDefault(_ReviewForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "ReviewersForm",
	  components: { Fragment: _vueFragment2.default, ReviewForm: _ReviewForm2.default },
	  props: {
	    reviews: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    reviewers: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  }
	};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Table = __webpack_require__(158);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _helpers = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "SubmissionsList",
	  components: { Table: _Table2.default },
	  data: function data() {
	    return {
	      articleList: [],
	      filterStatus: {},
	      actions: {
	        author: {
	          view: "viewLink",
	          edit: "editLink"
	        },
	        admin: {
	          view: "viewLink",
	          edit: "editLink",
	          review: "reviewLink"
	        },
	        reviewer: {
	          review: "reviewLink"
	        },
	        god: {
	          view: "viewLink",
	          edit: "editLink",
	          review: "reviewLink"
	        }
	      }
	    };
	  },
	
	  computed: {
	    isLoggedIn: function isLoggedIn() {
	      return this.$store.getters.isLoggedIn;
	    },
	    role: function role() {
	      return this.$store.getters.role;
	    },
	    status: function status() {
	      return _helpers.status[this.$store.getters.role];
	    }
	  },
	  mounted: function mounted() {
	    var _this = this;
	
	    if (this.isLoggedIn) {
	      this.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/articles/user", {
	        headers: {
	          Authorization: "Bearer " + this.$store.state.auth.token
	        }
	      }).then(function (response) {
	        _this.articleList = response.data.map(_helpers.articleDAO);
	      });
	    }
	  },
	
	  methods: {
	    setFilterStatus: function setFilterStatus(filter) {
	      this.filterStatus = filter;
	    }
	  }
	};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Register = __webpack_require__(49);
	
	var _Register2 = _interopRequireDefault(_Register);
	
	var _Login = __webpack_require__(48);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      showForm: this.$store.getters.isLoggedIn,
	      apiTerms: "",
	      apiLanguages: "",
	      apiLexicalUnits: "",
	      entry: {
	        id: "",
	        lexical: false,
	        new: false,
	        english: "",
	        section: ""
	      },
	      article: {
	        name_language: "",
	        title: "",
	        body: "",
	        img_url: "",
	        img_auth: true,
	        keyword1: "",
	        keyword2: "",
	        keyword3: "",
	        currentLink: "",
	        linkList: [],
	        linkValidation: false,
	        author: {
	          surname: "",
	          firstName: "",
	          affiliation: "",
	          mail: true
	        },
	        references: ""
	      },
	      definition: {
	        id: "",
	        langOriginSelected: "",
	        origin: "",
	        occurrence: "",
	        lang_orig_id: 0,
	        lang_occu_id: 0,
	        category: 0,
	        meaning: "",
	        synonyms: "",
	        notes: "",
	        author: {
	          surname: "",
	          firstName: "",
	          affiliation: "",
	          mail: true
	        },
	        references: ""
	      },
	      copyright: true,
	      validation: ""
	    };
	  },
	
	  components: {
	    Register: _Register2.default,
	    Login: _Login2.default
	  },
	  methods: {
	    showFormChange: function showFormChange() {
	      this.showForm = true;
	    },
	    langSelect: function langSelect(value) {
	      var app = this;
	      app.definition.langOriginSelected = value;
	      app.definition.lang_orig_id = 0;
	    },
	    selectListLexical: function selectListLexical() {
	      var app = this;
	      if (typeof app.entry.id === "string") {
	        app.entry.lexical = true;
	        var lexId = app.entry.id.replace("lu-", "");
	        app.definition.id = parseInt(lexId, 10);
	        app.lexicalPlaceholder();
	      } else {
	        app.entry.lexical = false;
	      }
	    },
	    lexicalPlaceholder: function lexicalPlaceholder() {
	      var app = this;
	      app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/lexicalunits/" + app.definition.id).then(function (response) {
	        var lexical = response.data;
	        app.definition.english = lexical.term_english;
	        app.definition.article = lexical.term_article;
	        app.definition.origin = lexical.term_orig;
	        app.definition.occurrence = lexical.term_occu;
	        app.definition.lang_orig_id = lexical.lang_orig_id;
	        app.definition.lang_occu_id = lexical.lang_occu_id;
	        app.definition.meaning = lexical.meaning;
	        app.definition.synonyms = lexical.synonyms;
	        app.definition.notes = lexical.notes;
	        app.definition.category = lexical.gramcategory_id;
	        app.definition.author.firstName = lexical.author_name;
	        app.definition.author.surname = lexical.author_surname;
	        app.definition.author.affiliation = lexical.author_affiliation;
	        app.definition.references = lexical.references;
	      });
	    },
	    uploadImage: function uploadImage() {
	      var app = this;
	      var formData = new FormData();
	      formData.append("imageFile", event.target.files[0]);
	      var token = this.$store.state.auth.token;
	      if (token) {
	        var config = {
	          headers: {
	            Authorization: "Bearer " + token,
	            "content-type": "multipart/form-data"
	          }
	        };
	        this.axios.post(("http://aen-api.fcsh.unl.pt/api/web") + "/images", formData, config).then(function (response) {
	          app.article.img_url = response.data.imageFile;
	        });
	      }
	    },
	    addLink: function addLink(value) {
	      var app = this;
	      if (app.article.linkList.length < 3) {
	        app.article.linkValidation = false;
	        app.article.linkList.push(value);
	      } else {
	        app.article.linkValidation = true;
	      }
	    },
	    removeLink: function removeLink(value) {
	      var app = this;
	      app.article.linkList.pop(value);
	      app.article.linkValidation = false;
	    },
	    validateEntry: function validateEntry() {
	      var app = this;
	      if (!app.entry.english && !app.entry.id) {
	        app.validation = "No entry selected or proposed";
	      } else if (app.entry.new && app.entry.section.length === 0) {
	        app.validation = "No section selected for new entry";
	      } else {
	        app.validateContent();
	      }
	    },
	    validateContent: function validateContent() {
	      var app = this;
	      if (!app.entry.lexical) {
	        app.validateArticle();
	      } else {
	        app.validateLexical();
	      }
	    },
	    validateArticle: function validateArticle() {
	      var app = this;
	      if (app.article.body === "") {
	        app.validation = "Article body field is empty";
	      } else if (app.article.img_url && !app.article.img_auth) {
	        app.validation = "Missing Creative Commons License declaration on image upload";
	      } else if (app.article.references === "") {
	        app.validation = "Bibliographic references is empty";
	      } else if (app.article.author.firstName === "") {
	        app.validation = "Author First Name is empty";
	      } else if (app.article.author.surname === "") {
	        app.validation = "Author Surname is empty";
	      } else if (app.copyright === "false") {
	        app.validation = "You must agree with the Terms of Use and Copyright of the Afro-European Cartography of Culture Language and Arts.";
	      } else {
	        app.createNewTerm();
	      }
	    },
	    createNewTerm: function createNewTerm() {
	      var app = this;
	      if (app.entry.new) {
	        var token = this.$store.state.auth.token;
	        if (token) {
	          var config = {
	            headers: { Authorization: "Bearer " + token }
	          };
	          app.axios.post(("http://aen-api.fcsh.unl.pt/api/web") + "/terms", {
	            term_english: app.entry.english,
	            term_article: app.entry.english,
	            definition: "No Definition",
	            section_id: app.entry.section
	          }, config).then(function (response) {
	            app.entry.id = response.data.id;
	            app.submitArticle();
	          }, config).catch(function (error) {
	            app.validation = error;
	          });
	        }
	      } else {
	        app.submitArticle();
	      }
	    },
	    submitArticle: function submitArticle() {
	      var app = this;
	      var token = this.$store.state.auth.token;
	      if (token) {
	        var config = {
	          headers: { Authorization: "Bearer " + token }
	        };
	        this.axios.post(("http://aen-api.fcsh.unl.pt/api/web") + "/articles", {
	          title: app.article.title,
	          term_org: app.article.name_language,
	          text: app.article.body,
	          term_id: app.entry.id,
	
	          author_name: app.article.author.firstName,
	          author_surname: app.article.author.surname,
	          author_affiliation: app.article.author.affiliation,
	          author_pub_auth: true,
	          img_url: app.article.img_url,
	          references: this.article.references,
	          keywords: [app.article.keyword1, app.article.keyword2, app.article.keyword3],
	          links: app.article.linkList
	        }, config).then(function (response) {
	          app.validation = response.data;
	          app.$router.push("/article/" + response.data.id);
	        }).catch(function (error) {
	          app.validation = error;
	        });
	      }
	    },
	    validateLexical: function validateLexical() {
	      var app = this;
	      if (app.definition.lang_occu_id === 0) {
	        app.validation = "No target language selected";
	      } else if (app.definition.lang_orig_id === 0) {
	        app.validation = "No source language selected";
	      } else if (app.definition.category === "") {
	        app.validation = "You must select a grammatical category";
	      } else if (app.definition.references === "") {
	        app.validation = "Bibliographic references is empty";
	      } else if (app.definition.author.firstName === "") {
	        app.validation = "Author First Name is empty";
	      } else if (app.definition.author.surname === "") {
	        app.validation = "Author Surname is empty";
	      } else if (app.copyright === "false") {
	        app.validation = "You must agree with the Terms of Use and Copyright of the Afro-European Cartography of Culture Language and Arts.";
	      } else {
	        app.submitLexical();
	      }
	    },
	    submitLexical: function submitLexical() {
	      var app = this;
	      if (app.entry.new) {
	        var token = this.$store.state.auth.token;
	        if (token) {
	          var config = {
	            headers: { Authorization: "Bearer " + token }
	          };
	          app.axios.post(("http://aen-api.fcsh.unl.pt/api/web") + "/lexicalunits", {
	            term_english: app.entry.english,
	            term_article: app.entry.english,
	            term_orig: app.definition.origin,
	            term_occu: app.definition.occurrence,
	            lang_orig_id: app.definition.lang_orig_id,
	            lang_occu_id: app.definition.lang_occu_id,
	            meaning: app.definition.meaning,
	            synonyms: app.definition.synonyms,
	            notes: app.definition.notes,
	            gramcategory_id: app.definition.category,
	            author_name: app.definition.author.firstName,
	            author_surname: app.definition.author.surname,
	            author_affiliation: app.definition.author.affiliation,
	            author_pub_auth: true,
	            references: app.definition.references
	          }, config).then(function (response) {
	            app.entry.id = response.data.id;
	            app.$router.push("/lexical/" + response.data.id);
	          }).catch(function (error) {
	            app.validation = error;
	          });
	        }
	      } else {
	        var _token = this.$store.state.auth.token;
	        if (_token) {
	          var _config = {
	            headers: { Authorization: "Bearer " + _token }
	          };
	          app.axios.patch(("http://aen-api.fcsh.unl.pt/api/web") + "/lexicalunits/" + app.definition.id, {
	            term_english: app.definition.english,
	            term_article: app.definition.article,
	            term_orig: app.definition.origin,
	            term_occu: app.definition.occurrence,
	            lang_orig_id: app.definition.lang_orig_id,
	            lang_occu_id: app.definition.lang_occu_id,
	            meaning: app.definition.meaning,
	            synonyms: app.definition.synonyms,
	            notes: app.definition.notes,
	            gramcategory_id: app.definition.category,
	            author_name: app.definition.author.firstName,
	            author_surname: app.definition.author.surname,
	            author_affiliation: app.definition.author.affiliation,
	            author_pub_auth: true,
	            references: app.definition.references
	          }, _config).then(function (response) {
	            app.$router.push("/lexical/" + app.definition.id);
	          }).catch(function (error) {
	            app.validation = error;
	          });
	        }
	      }
	    }
	  },
	  mounted: function mounted() {
	    var app = this;
	
	    app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/terms").then(function (response) {
	      app.apiTerms = response.data;
	    });
	    app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/languages").then(function (response) {
	      app.apiLanguages = response.data;
	    });
	    app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/gramcategories").then(function (response) {
	      app.apiGramCategories = response.data;
	    });
	    app.axios.get(("http://aen-api.fcsh.unl.pt/api/web") + "/lexicalunits").then(function (response) {
	      app.apiLexicalUnits = response.data;
	    });
	  }
	};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(89);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "Table",
	  props: {
	    items: Array,
	    columns: Array,
	    filterKey: {
	      type: String,
	      default: ""
	    },
	    filterField: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    },
	    actions: {
	      type: Object,
	      default: function _default() {
	        return {};
	      }
	    }
	  },
	  data: function data() {
	    var sortOrders = {};
	    this.columns.forEach(function (key) {
	      sortOrders[key] = 1;
	    });
	    return {
	      sortKey: "",
	      sortOrders: sortOrders
	    };
	  },
	  computed: {
	    filteredItems: function filteredItems() {
	      var _this = this;
	
	      var sortKey = this.sortKey;
	      var filterKey = this.filterKey && this.filterKey.toLowerCase();
	      var order = this.sortOrders[sortKey] || 1;
	      var items = this.items;
	      if (filterKey) {
	        items = items.filter(function (row) {
	          return (0, _keys2.default)(row).some(function (key) {
	            return String(row[key]).toLowerCase().indexOf(filterKey) > -1;
	          });
	        });
	      }
	      if ((0, _keys2.default)(this.filterField).includes("key") && (0, _keys2.default)(this.filterField).includes("value")) {
	        items = items.filter(function (row) {
	          return row[_this.filterField.key] === _this.filterField.value;
	        });
	      }
	      if (sortKey) {
	        items = items.slice().sort(function (a, b) {
	          a = a[sortKey];
	          b = b[sortKey];
	          return (a === b ? 0 : a > b ? 1 : -1) * order;
	        });
	      }
	      return items;
	    }
	  },
	  filters: {
	    capitalize: function capitalize(str) {
	      return str.charAt(0).toUpperCase() + str.slice(1);
	    }
	  },
	  methods: {
	    sortBy: function sortBy(key) {
	      this.sortKey = key;
	      this.sortOrders[key] = this.sortOrders[key] * -1;
	    }
	  }
	};

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(23);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(175);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _store = __webpack_require__(32);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Hello = __webpack_require__(150);
	
	var _Hello2 = _interopRequireDefault(_Hello);
	
	var _Submit = __webpack_require__(157);
	
	var _Submit2 = _interopRequireDefault(_Submit);
	
	var _ArticlePage = __webpack_require__(148);
	
	var _ArticlePage2 = _interopRequireDefault(_ArticlePage);
	
	var _EditPage = __webpack_require__(149);
	
	var _EditPage2 = _interopRequireDefault(_EditPage);
	
	var _LexicalUnit = __webpack_require__(151);
	
	var _LexicalUnit2 = _interopRequireDefault(_LexicalUnit);
	
	var _Login = __webpack_require__(48);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Register = __webpack_require__(49);
	
	var _Register2 = _interopRequireDefault(_Register);
	
	var _ReviewPage = __webpack_require__(154);
	
	var _ReviewPage2 = _interopRequireDefault(_ReviewPage);
	
	var _SubmissionsList = __webpack_require__(156);
	
	var _SubmissionsList2 = _interopRequireDefault(_SubmissionsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	
	var router = new _vueRouter2.default({
	  mode: "hash",
	  routes: [{ path: "/", component: _Hello2.default }, { path: "/submit", component: _Submit2.default }, { path: "/login", component: _Login2.default }, { path: "/register", component: _Register2.default }, { path: "/article/:id", component: _ArticlePage2.default }, { path: "/lexical/:id", component: _LexicalUnit2.default }, {
	    path: "/submissions",
	    component: _SubmissionsList2.default,
	    meta: { requiresAuth: true }
	  }, {
	    path: "/article/:id/edit",
	    component: _EditPage2.default,
	    meta: { requiresAuth: true }
	  }, {
	    path: "/article/:id/review",
	    component: _ReviewPage2.default,
	    meta: { requiresAuth: true }
	  }]
	});
	
	router.beforeEach(function (to, from, next) {
	  if (to.matched.some(function (record) {
	    return record.meta.requiresAuth;
	  })) {
	    if (_store2.default.getters.isLoggedIn) {
	      next();
	      return;
	    }
	    next({
	      path: "/login",
	      query: { redirect: to.fullPath }
	    });
	  } else {
	    next();
	  }
	});
	
	exports.default = router;

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(137)
	
	/* script */
	__vue_exports__ = __webpack_require__(68)
	
	/* template */
	var __vue_template__ = __webpack_require__(168)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(70)
	
	/* template */
	var __vue_template__ = __webpack_require__(171)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(138)
	
	/* script */
	__vue_exports__ = __webpack_require__(71)
	
	/* template */
	var __vue_template__ = __webpack_require__(169)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(141)
	
	/* script */
	__vue_exports__ = __webpack_require__(72)
	
	/* template */
	var __vue_template__ = __webpack_require__(174)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(131)
	
	/* script */
	__vue_exports__ = __webpack_require__(73)
	
	/* template */
	var __vue_template__ = __webpack_require__(160)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(133)
	
	/* script */
	__vue_exports__ = __webpack_require__(74)
	
	/* template */
	var __vue_template__ = __webpack_require__(163)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(76)
	
	/* template */
	var __vue_template__ = __webpack_require__(161)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(134)
	
	/* script */
	__vue_exports__ = __webpack_require__(79)
	
	/* template */
	var __vue_template__ = __webpack_require__(164)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(135)
	
	/* script */
	__vue_exports__ = __webpack_require__(80)
	
	/* template */
	var __vue_template__ = __webpack_require__(166)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(130)
	
	/* script */
	__vue_exports__ = __webpack_require__(81)
	
	/* template */
	var __vue_template__ = __webpack_require__(159)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(140)
	
	/* script */
	__vue_exports__ = __webpack_require__(82)
	
	/* template */
	var __vue_template__ = __webpack_require__(173)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(136)
	
	/* script */
	__vue_exports__ = __webpack_require__(83)
	
	/* template */
	var __vue_template__ = __webpack_require__(167)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 159 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Submission History")]), _vm._v(" "), _c('p', {
	    staticClass: "filters"
	  }, [_vm._v("\n    Filter by status:\n    "), _c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.setFilterStatus({})
	      }
	    }
	  }, [_vm._v("All")]), _vm._v(" "), _vm._l((Object.keys(_vm.status)), function(st) {
	    return _c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.setFilterStatus({
	            key: 'status',
	            value: _vm.status[st]
	          })
	        }
	      }
	    }, [_vm._v("\n      " + _vm._s(_vm.status[st]))])
	  })], 2), _vm._v(" "), _c('Table', {
	    attrs: {
	      "items": _vm.articleList,
	      "columns": [
	        'title',
	        'term' ].concat( (['admin', 'god'].includes(_vm.role) ? ['author'] : []),
	        ['status'],
	        ['date'] ),
	      "actions": _vm.actions[_vm.role],
	      "filterField": _vm.filterStatus
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container lexical"
	  }, [_c('h4', {
	    staticClass: "lexical-title"
	  }, [_vm._v("\n          " + _vm._s(_vm.lexical.term_english) + "\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "lexical-references"
	  }, [_c('h5', [_vm._v("Target Language")]), _vm._v(" "), _vm._l((_vm.apiLanguages), function(lang) {
	    return _c('div', [(lang.id === _vm.lexical.lang_occu_id) ? _c('p', [_vm._v("\n                  " + _vm._s(lang.name) + "\n              ")]) : _vm._e()])
	  }), _vm._v(" "), _c('h5', [_vm._v("Source Language")]), _vm._v(" "), _vm._l((_vm.apiLanguages), function(lang) {
	    return _c('div', [(lang.id === _vm.lexical.lang_orig_id) ? _c('p', [_vm._v("\n                  " + _vm._s(lang.name) + "\n              ")]) : _vm._e()])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "lexical-references"
	  }, [_c('h5', [_vm._v("Grammatical category")]), _vm._v(" "), _vm._l((_vm.apiGramCategories), function(gram) {
	    return _c('div', [(gram.id === _vm.lexical.gramcategory_id) ? _c('p', [_vm._v("\n                  " + _vm._s(gram.long_name) + "\n              ")]) : _vm._e()])
	  })], 2), _vm._v(" "), (_vm.lexical.meaning) ? _c('div', {
	    staticClass: "lexical-references"
	  }, [_c('h5', [_vm._v("Meaning")]), _vm._v(" "), _c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.lexical.meaning)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.lexical.synonyms) ? _c('div', {
	    staticClass: "lexical-references"
	  }, [_c('h5', [_vm._v("Synonyms")]), _vm._v(" "), _c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.lexical.synonyms)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.lexical.notes) ? _c('div', {
	    staticClass: "lexical-references"
	  }, [_c('h5', [_vm._v("Notes")]), _vm._v(" "), _c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.lexical.notes)
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.lexical.references) ? _c('div', {
	    staticClass: "lexical-references"
	  }, [_c('h5', [_vm._v("Bibliographic References")]), _vm._v(" "), _c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.lexical.references)
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "lexical-author"
	  }, [_vm._v("\n          Contribution from " + _vm._s(_vm.lexical.author_name) + " " + _vm._s(_vm.lexical.author_surname) + " (" + _vm._s(_vm.lexical.author_affiliation) + ")\n      ")])])
	},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "header-sticky",
	    attrs: {
	      "id": "sp-header"
	    }
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "container-inner"
	  }, [_c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "position": "relative"
	    }
	  }, [_c('div', {
	    staticClass: "col-6 col-sm-6 col-md-6 col-lg-2 ",
	    attrs: {
	      "id": "sp-logo"
	    }
	  }, [_c('div', {
	    staticClass: "sp-column "
	  }, [_c('div', {
	    staticClass: "logo"
	  }, [_c('a', {
	    attrs: {
	      "href": "/"
	    }
	  }, [_c('img', {
	    staticClass: "logo-image",
	    attrs: {
	      "src": "static/images/homepage_logo2.png",
	      "alt": " AFRICAN - EUROPEAN NARRATIVES"
	    }
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-6 col-sm-6 col-md-6 col-lg-8 ",
	    staticStyle: {
	      "position": "static"
	    },
	    attrs: {
	      "id": "sp-menu"
	    }
	  }, [_c('div', {
	    staticClass: "sp-column "
	  }, [_c('nav', {
	    staticClass: "sp-megamenu-wrapper",
	    attrs: {
	      "role": "navigation"
	    }
	  }, [_c('a', {
	    staticClass: "offcanvas-toggler-right",
	    attrs: {
	      "id": "offcanvas-toggler",
	      "aria-label": "Navigation",
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-bars",
	    attrs: {
	      "aria-hidden": "true",
	      "title": "Navigation"
	    }
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "sp-megamenu-parent menu-animation-fade-up d-none d-lg-block"
	  }, [_c('li', {
	    staticClass: "sp-menu-item"
	  }, [_c('a', {
	    attrs: {
	      "href": "/en/"
	    }
	  }, [_vm._v("All Stories")])]), _vm._v(" "), _c('li', {
	    staticClass: "sp-menu-item sp-has-child"
	  }, [_c('a', {
	    attrs: {
	      "href": "/en/testimonies"
	    }
	  }, [_vm._v("Testimonies")]), _vm._v(" "), _c('div', {
	    staticClass: "sp-dropdown sp-dropdown-main sp-menu-right",
	    staticStyle: {
	      "width": "240px"
	    }
	  }, [_c('div', {
	    staticClass: "sp-dropdown-inner"
	  }, [_c('ul', {
	    staticClass: "sp-dropdown-items"
	  }, [_c('li', {
	    staticClass: "sp-menu-item"
	  }), _vm._v(" "), _c('li', {
	    staticClass: "sp-menu-item"
	  }), _vm._v(" "), _c('li', {
	    staticClass: "sp-menu-item"
	  }), _vm._v(" "), _c('li', {
	    staticClass: "sp-menu-item"
	  }), _vm._v(" "), _c('li', {
	    staticClass: "sp-menu-item"
	  }), _vm._v(" "), _c('li', {
	    staticClass: "sp-menu-item"
	  }), _vm._v(" "), _c('li', {
	    staticClass: "sp-menu-item"
	  }), _vm._v(" "), _c('li', {
	    staticClass: "sp-menu-item"
	  }), _vm._v(" "), _c('li', {
	    staticClass: "sp-menu-item"
	  }), _vm._v(" "), _c('li', {
	    staticClass: "sp-menu-item"
	  })])])])]), _vm._v(" "), _c('li', {
	    staticClass: "sp-menu-item"
	  }, [_c('a', {
	    attrs: {
	      "href": "/en/about"
	    }
	  }, [_vm._v("About")])]), _vm._v(" "), _c('li', {
	    staticClass: "sp-menu-item"
	  }, [_c('a', {
	    attrs: {
	      "href": "/en/glossary"
	    }
	  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('li', {
	    staticClass: "sp-menu-item"
	  }), _vm._v(" "), _c('li', {
	    staticClass: "sp-menu-item current-item active"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-lg-2 ",
	    attrs: {
	      "id": "sp-position2"
	    }
	  }, [_c('div', {
	    staticClass: "sp-column "
	  }, [_c('div', {
	    staticClass: "sp-module  mod-search-fcsh"
	  }, [_c('div', {
	    staticClass: "sp-module-content"
	  }, [_c('div', {
	    staticClass: "custom mod-search-fcsh"
	  }, [_c('p', [_c('a', {
	    attrs: {
	      "href": "/en/search"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "margin": "0 0 0 auto"
	    },
	    attrs: {
	      "src": "static/images/icons/search2.png",
	      "alt": ""
	    }
	  })])])])])])])])])])])])
	}]}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form container"
	  }, [_c('div', {
	    staticClass: "form-article formResponsive formHorizontal"
	  }, [_c('div', {
	    staticClass: "form-article-item form-article-item-approved"
	  }, [_c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "review-approved-yes"
	    }
	  }, [_c('input', {
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "radio",
	      "id": "review-approved-yes",
	      "disabled": _vm.disabled
	    },
	    domProps: {
	      "value": _vm.review.approved,
	      "checked": _vm.review.approved
	    },
	    on: {
	      "input": function($event) {
	        _vm.review.approved = true
	      }
	    }
	  }), _vm._v("\n        Approved\n        "), _c('span', {
	    staticClass: "checkmark"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "review-approved-no"
	    }
	  }, [_c('input', {
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "radio",
	      "id": "review-approved-no",
	      "disabled": _vm.disabled
	    },
	    domProps: {
	      "value": _vm.review.approved,
	      "checked": !_vm.review.approved
	    },
	    on: {
	      "input": function($event) {
	        _vm.review.approved = false
	      }
	    }
	  }), _vm._v("\n        Not Approved\n        "), _c('span', {
	    staticClass: "checkmark"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item form-article-item-corrections"
	  }, [_c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "review-corrections-yes"
	    }
	  }, [_c('input', {
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "radio",
	      "id": "review-corrections-yes",
	      "disabled": _vm.disabled
	    },
	    domProps: {
	      "value": _vm.review.corrections,
	      "checked": _vm.review.corrections
	    },
	    on: {
	      "input": function($event) {
	        _vm.review.corrections = true
	      }
	    }
	  }), _vm._v("\n        With corrections\n        "), _c('span', {
	    staticClass: "checkmark"
	  })]), _vm._v(" "), _c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "review-corrections-no"
	    }
	  }, [_c('input', {
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "radio",
	      "id": "review-corrections-no",
	      "disabled": _vm.disabled
	    },
	    domProps: {
	      "value": _vm.review.corrections,
	      "checked": !_vm.review.corrections
	    },
	    on: {
	      "input": function($event) {
	        _vm.review.corrections = false
	      }
	    }
	  }), _vm._v("\n        Without corrections\n        "), _c('span', {
	    staticClass: "checkmark"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item form-article-item-text"
	  }, [(!_vm.disabled) ? _c('wysiwyg', {
	    staticClass: "text-editor",
	    model: {
	      value: (_vm.review.text),
	      callback: function($$v) {
	        _vm.$set(_vm.review, "text", $$v)
	      },
	      expression: "review.text"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.disabled) ? _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.review.text),
	      expression: "review.text"
	    }],
	    staticClass: "text-editor",
	    attrs: {
	      "disabled": ""
	    },
	    domProps: {
	      "value": (_vm.review.text)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.review, "text", $event.target.value)
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('p', {
	    staticClass: "footer"
	  }, [_vm._v("\n        Obligatory in case of non approval or approval with corrections; these\n        notes will be e-mailed to the author. Máx 2000 carat.\n      ")])], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "sp-submitastory"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-lg-12",
	    attrs: {
	      "id": "sp-position-0"
	    }
	  }, [_c('div', {
	    staticClass: "sp-column"
	  }, [_c('div', {
	    staticClass: "sp-module"
	  }, [_c('div', {
	    staticClass: "sp-module-content"
	  }, [_c('div', {
	    staticClass: "custom"
	  }, [_c('p', {
	    staticStyle: {
	      "font-weight": "bold",
	      "font-size": "17px"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "float": "left",
	      "padding-right": "5px",
	      "padding-top": "5px"
	    },
	    attrs: {
	      "src": "/static/img/icons/submit_story.png",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/submit"
	    }
	  }, [_vm._v("Submit an entry")])], 1)])])]), _vm._v(" "), (!_vm.isLoggedIn) ? _c('div', {
	    staticClass: "sp-module"
	  }, [_c('div', {
	    staticClass: "sp-module-content"
	  }, [_c('div', {
	    staticClass: "custom"
	  }, [_c('p', {
	    staticStyle: {
	      "font-weight": "bold",
	      "font-size": "17px"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "float": "left",
	      "padding-right": "5px",
	      "padding-top": "5px"
	    },
	    attrs: {
	      "src": "/static/img/icons/submit_story.png",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/login?redirect=%2Fsubmissions"
	    }
	  }, [_vm._v("Sign in to Glossary")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
	    staticClass: "sp-module"
	  }, [_c('div', {
	    staticClass: "sp-module-content"
	  }, [_c('div', {
	    staticClass: "custom"
	  }, [_c('p', {
	    staticStyle: {
	      "font-weight": "bold",
	      "font-size": "17px"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "float": "left",
	      "padding-right": "5px",
	      "padding-top": "5px"
	    },
	    attrs: {
	      "src": "/static/img/icons/submit_story.png",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/submissions"
	    }
	  }, [_vm._v("Submissions")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('div', {
	    staticClass: "sp-module"
	  }, [_c('div', {
	    staticClass: "sp-module-content"
	  }, [_c('div', {
	    staticClass: "custom"
	  }, [_c('p', {
	    staticStyle: {
	      "font-weight": "bold",
	      "font-size": "17px"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "float": "left",
	      "padding-right": "5px",
	      "padding-top": "5px"
	    },
	    attrs: {
	      "src": "/static/img/icons/submit_story.png",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.logout()
	      }
	    }
	  }, [_vm._v("Logout")])])])])]) : _vm._e()])])])])
	},staticRenderFns: []}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('Fragment', [_c('div', {
	    staticClass: "container"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Review entry")]), _vm._v(" "), _c('Article', {
	    attrs: {
	      "article": _vm.article,
	      "showAuthor": _vm.role !== 'reviewer',
	      "term": _vm.term
	    }
	  })], 1), _vm._v(" "), (['reviewer', 'admin', 'god'].includes(_vm.role)) ? _c('div', {
	    staticClass: "container-fluid yellow"
	  }, [(['admin', 'god'].includes(_vm.role)) ? _c('div', {
	    staticClass: "container"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Review Assignments")]), _vm._v(" "), _c('ReviewersForm', {
	    attrs: {
	      "reviewers": _vm.reviewers,
	      "reviews": _vm.reviews
	    }
	  }), _vm._v(" "), ((_vm.reviews[0].text && _vm.reviews[0].text.length > 0) || (_vm.reviews[1].text && _vm.reviews[1].text.length > 0)) ? _c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Reviewing")]) : _vm._e(), _vm._v(" "), (_vm.reviews[0].text && _vm.reviews[0].text.length > 0) ? _c('ReviewForm', {
	    attrs: {
	      "disabled": true,
	      "review": _vm.reviews[0]
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.reviews[1].text && _vm.reviews[1].text.length > 0) ? _c('ReviewForm', {
	    attrs: {
	      "disabled": true,
	      "review": _vm.reviews[1]
	    }
	  }) : _vm._e(), _vm._v(" "), (['god', 'admin'].includes(_vm.role)) ? _c('div', {
	    staticClass: "container"
	  }, [_c('label', [_vm._v("STATUS")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.status),
	      expression: "status"
	    }],
	    staticClass: "status-select",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        return _vm.updateStatus()
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, [_vm._v("Needs Corrections")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "disabled": "",
	      "value": "10"
	    }
	  }, [_vm._v("Submitted")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "40"
	    }
	  }, [_vm._v("Refused")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "50"
	    }
	  }, [_vm._v("Published")])])]) : _vm._e(), _vm._v(" "), _c('input', {
	    attrs: {
	      "value": "Finish",
	      "type": "submit",
	      "name": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submitReviews()
	      }
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.role === 'reviewer') ? _c('div', {
	    staticClass: "container"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Reviewing")]), _vm._v(" "), _c('ReviewForm', {
	    attrs: {
	      "review": _vm.reviews[0]
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "value": "Finish",
	      "type": "submit",
	      "name": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submitReview(_vm.reviews[0])
	      }
	    }
	  })], 1) : _vm._e()]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form container"
	  }, [_c('div', {
	    staticClass: "form-register formResponsive"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Log In")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "inline"
	  }, [_vm._v("E-mail Address")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.login.email),
	      expression: "login.email"
	    }],
	    staticClass: "inline",
	    attrs: {
	      "type": "text",
	      "name": ""
	    },
	    domProps: {
	      "value": (_vm.login.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.login, "email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "inline"
	  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.login.password),
	      expression: "login.password"
	    }],
	    staticClass: "inline",
	    attrs: {
	      "type": "password",
	      "name": ""
	    },
	    domProps: {
	      "value": (_vm.login.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.login, "password", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "submit",
	      "value": "Log In"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.validateLogin()
	      }
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
	    staticClass: "validation"
	  }, [_vm._v(_vm._s(_vm.loginValidation))])])])
	},staticRenderFns: []}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form container"
	  }, [_c('div', {
	    staticClass: "form-article formResponsive formHorizontal"
	  }, [_c('div', {
	    staticClass: "form-article-item form-article-item-reviewers"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.reviews[0].user_id),
	      expression: "reviews[0].user_id"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.reviews[0], "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        _vm.reviews[0].text = '';
	        (_vm.reviews[0].approved = false), (_vm.reviews[0].corrections = false);
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": "0"
	    }
	  }, [_vm._v("Choose a Reviewer")]), _vm._v(" "), _vm._l((_vm.reviewers), function(user) {
	    return _c('option', {
	      domProps: {
	        "value": user.id
	      }
	    }, [_vm._v("\n          " + _vm._s(user.username) + "\n        ")])
	  })], 2), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.reviews[1].user_id),
	      expression: "reviews[1].user_id"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.reviews[1], "user_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        _vm.reviews[1].text = '';
	        (_vm.reviews[1].approved = false), (_vm.reviews[1].corrections = false);
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": "0"
	    }
	  }, [_vm._v("Choose a Reviewer")]), _vm._v(" "), _vm._l((_vm.reviewers), function(user) {
	    return _c('option', {
	      domProps: {
	        "value": user.id
	      }
	    }, [_vm._v("\n          " + _vm._s(user.username) + "\n        ")])
	  })], 2)])])])
	},staticRenderFns: []}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('table', {
	    staticClass: "table-component",
	    attrs: {
	      "cellspacing": "0"
	    }
	  }, [_c('thead', [_c('tr', [_vm._l((_vm.columns), function(key) {
	    return _c('th', {
	      class: {
	        active: _vm.sortKey == key
	      },
	      on: {
	        "click": function($event) {
	          return _vm.sortBy(key)
	        }
	      }
	    }, [_vm._v("\n        " + _vm._s(_vm._f("capitalize")(key)) + "\n        "), _c('span', {
	      staticClass: "arrow",
	      class: _vm.sortOrders[key] > 0 ? 'asc' : 'dsc'
	    })])
	  }), _vm._v(" "), (Object.keys(_vm.actions).length > 0) ? _c('th', [_vm._v(" ")]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredItems), function(entry) {
	    return _c('tr', [_vm._l((_vm.columns), function(key) {
	      return _c('td', [_vm._v(_vm._s(entry[key]))])
	    }), _vm._v(" "), _c('td', _vm._l((_vm.actions), function(urlKey, action) {
	      return _c('router-link', {
	        attrs: {
	          "to": entry[urlKey]
	        }
	      }, [_vm._v("\n          " + _vm._s(action) + "\n        ")])
	    }), 1)], 2)
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "sp-main-body"
	    }
	  }, [_c('router-view', {
	    key: _vm.$route.fullPath
	  }), _vm._v(" "), _c('linkBlock')], 1)])
	},staticRenderFns: []}

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form container"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Edit entry")]), _vm._v(" "), _c('div', {
	    staticClass: "form-article formResponsive formHorizontal"
	  }, [(!_vm.showForm) ? _c('div', {
	    staticClass: "formCover"
	  }) : _vm._e(), _vm._v(" "), (!_vm.entry.lexical) ? _c('div', {
	    staticClass: "form-article-item article"
	  }, [_c('div', {
	    staticClass: "form-article-item"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Article")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n          Term: " + _vm._s(_vm.article.name_language) + "\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.title),
	      expression: "article.title"
	    }],
	    attrs: {
	      "type": "text",
	      "name": ""
	    },
	    domProps: {
	      "value": (_vm.article.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.article, "title", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('wysiwyg', {
	    model: {
	      value: (_vm.article.body),
	      callback: function($$v) {
	        _vm.$set(_vm.article, "body", $$v)
	      },
	      expression: "article.body"
	    }
	  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Illustrations")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Optional (Maximum 1 image)")]), _vm._v(" "), _c('input', {
	    staticClass: "imageinput",
	    attrs: {
	      "type": "file"
	    },
	    on: {
	      "change": _vm.uploadImage
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Pictures (Photos, Drawings, etc). Allowed files: .jpg .png .gif")]), _vm._v(" "), (_vm.article.img_url) ? _c('div', {
	    staticClass: "image-consent"
	  }, [_c('label', {
	    staticClass: "container2 inline",
	    attrs: {
	      "for": "expressconsent0"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.img_auth),
	      expression: "article.img_auth"
	    }],
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "checkbox",
	      "value": "true"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.article.img_auth) ? _vm._i(_vm.article.img_auth, "true") > -1 : (_vm.article.img_auth)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.article.img_auth,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "true",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.article, "img_auth", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.article, "img_auth", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.article, "img_auth", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "checkmark"
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "inline"
	  }, [_vm._v("\n            The user declares that the submitted content has a Creative Commons License or is\n            covered by copyright to which they have a valid license.\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Keywords")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Please write your keywords in english (maximum 3).")]), _vm._v(" "), _c('div', {
	    staticClass: "rsform-block"
	  }, [_c('div', {
	    staticClass: "formControls"
	  }, [_c('div', {
	    staticClass: "formBody"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.keyword1),
	      expression: "article.keyword1"
	    }],
	    staticClass: "rsform-input-box",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "size": "20",
	      "placeholder": "1."
	    },
	    domProps: {
	      "value": (_vm.article.keyword1)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.article, "keyword1", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "formDescription"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "rsform-block"
	  }, [_c('div', {
	    staticClass: "formControls"
	  }, [_c('div', {
	    staticClass: "formBody"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.keyword2),
	      expression: "article.keyword2"
	    }],
	    staticClass: "rsform-input-box",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "size": "20",
	      "placeholder": "2."
	    },
	    domProps: {
	      "value": (_vm.article.keyword2)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.article, "keyword2", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "formDescription"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "rsform-block"
	  }, [_c('div', {
	    staticClass: "formControls"
	  }, [_c('div', {
	    staticClass: "formBody"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.keyword3),
	      expression: "article.keyword3"
	    }],
	    staticClass: "rsform-input-box",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "size": "20",
	      "placeholder": "3."
	    },
	    domProps: {
	      "value": (_vm.article.keyword3)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.article, "keyword3", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "formDescription"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Hyperlinks")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Choose a maximum of 3 hyperlinks to other terms.")]), _vm._v(" "), _c('span', {
	    staticClass: "tit2"
	  }, [_vm._v("All Terms (A-Z)")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.currentLink),
	      expression: "article.currentLink"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.article, "currentLink", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "label": "Choose a Term"
	    }
	  }), _vm._v(" "), _c('optgroup', {
	    attrs: {
	      "label": "Epistemologies"
	    }
	  }, _vm._l((_vm.apiTerms), function(term) {
	    return (term.section_id === 1) ? _c('option', {
	      domProps: {
	        "value": term.id
	      }
	    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
	  }), 0), _vm._v(" "), _c('optgroup', {
	    attrs: {
	      "label": "History and Genealogy"
	    }
	  }, _vm._l((_vm.apiTerms), function(term) {
	    return (term.section_id === 2) ? _c('option', {
	      domProps: {
	        "value": term.id
	      }
	    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
	  }), 0), _vm._v(" "), _c('optgroup', {
	    attrs: {
	      "label": "Cultural Practices and Performativities"
	    }
	  }, _vm._l((_vm.apiTerms), function(term) {
	    return (term.section_id === 3) ? _c('option', {
	      domProps: {
	        "value": term.id
	      }
	    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
	  }), 0), _vm._v(" "), _c('optgroup', {
	    attrs: {
	      "label": "Linguistic Uses"
	    }
	  }, _vm._l((_vm.apiTerms), function(term) {
	    return (term.section_id === 4) ? _c('option', {
	      domProps: {
	        "value": term.id
	      }
	    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
	  }), 0), _vm._v(" "), _c('optgroup', {
	    attrs: {
	      "label": "Arts, Literatures and imaginaries"
	    }
	  }, _vm._l((_vm.apiTerms), function(term) {
	    return (term.section_id === 5) ? _c('option', {
	      domProps: {
	        "value": term.id
	      }
	    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
	  }), 0)]), _vm._v(" "), _c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.addLink(_vm.article.currentLink)
	      }
	    }
	  }, [_vm._v("Add")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_vm._l((_vm.article.linkList), function(link) {
	    return _c('li', _vm._l((_vm.apiTerms), function(term) {
	      return (term.id === link) ? _c('span', [_vm._v("\n              " + _vm._s(term.term_english) + " -\n              "), _c('button', {
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            return _vm.removeLink(_vm.article.currentLink)
	          }
	        }
	      }, [_vm._v("Remove")])]) : _vm._e()
	    }), 0)
	  }), _vm._v(" "), (_vm.article.linkValidation) ? _c('p', [_vm._v("Maximum 3 Links")]) : _vm._e()], 2), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Bibliographic References")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('wysiwyg', {
	    model: {
	      value: (_vm.article.references),
	      callback: function($$v) {
	        _vm.$set(_vm.article, "references", $$v)
	      },
	      expression: "article.references"
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Include 3 to 5 bibliographic references within a maximum of 1000 characters (total).")]), _vm._v(" "), _c('p', [_vm._v("The references must follow the Publication Guidelines.")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Author")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "tit2"
	  }, [_vm._v("Name")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.author.surname),
	      expression: "article.author.surname"
	    }],
	    staticClass: "inline",
	    attrs: {
	      "type": "text",
	      "placeholder": "Surname"
	    },
	    domProps: {
	      "value": (_vm.article.author.surname)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.article.author, "surname", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.author.firstName),
	      expression: "article.author.firstName"
	    }],
	    staticClass: "inline",
	    attrs: {
	      "type": "text",
	      "placeholder": "First name and middle name"
	    },
	    domProps: {
	      "value": (_vm.article.author.firstName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.article.author, "firstName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "tit2"
	  }, [_vm._v("Affiliation and Funding Reference")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.author.affiliation),
	      expression: "article.author.affiliation"
	    }],
	    domProps: {
	      "value": (_vm.article.author.affiliation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.article.author, "affiliation", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Max 300 characters")])])]) : _vm._e(), _vm._v(" "), _c('input', {
	    attrs: {
	      "value": "Submit",
	      "type": "submit",
	      "name": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.validateArticle()
	      }
	    }
	  }), _vm._v(" "), (_vm.$store.state.auth.role === 'author') ? _c('input', {
	    attrs: {
	      "value": "Delete",
	      "type": "submit",
	      "name": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.deleteArticle()
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
	    staticClass: "validation"
	  }, [_vm._v(_vm._s(_vm.validation))])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_vm._v("\n          Title\n          "), _c('p', [_vm._v("(optional)")])])
	}]}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "article"
	  }, [(_vm.term) ? _c('h1', {
	    staticClass: "article-term"
	  }, [_vm._v(_vm._s(_vm.article.term_org))]) : _vm._e(), _vm._v(" "), _c('p', {
	    staticClass: "article-term"
	  }, [_vm._v(_vm._s(_vm.term))]), _vm._v(" "), _c('h4', {
	    staticClass: "article-title"
	  }, [_c('i', [_vm._v(_vm._s(_vm.article.title))])]), _vm._v(" "), (_vm.article.keywords) ? _c('div', {
	    staticClass: "article-tags"
	  }, _vm._l((_vm.article.keywords), function(tag) {
	    return _c('span', [_vm._v(_vm._s(tag.keyword))])
	  }), 0) : _vm._e(), _vm._v(" "), (_vm.article.links) ? _c('div', {
	    staticClass: "article-links"
	  }, _vm._l((_vm.article.links), function(link) {
	    return _c('span', [_c('router-link', {
	      attrs: {
	        "to": '/article/' + link.id
	      }
	    }, [_vm._v("\n        " + _vm._s(link.term_english) + "\n      ")])], 1)
	  }), 0) : _vm._e(), _vm._v(" "), (_vm.article.img_url) ? _c('img', {
	    staticClass: "article-img",
	    attrs: {
	      "src": 'images/' + _vm.article.img_url
	    }
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "article-body",
	    domProps: {
	      "innerHTML": _vm._s(_vm.article.text)
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "article-references"
	  }, [_c('h3', [_vm._v("BIBLIOGRAPHIC REFERENCES")]), _vm._v(" "), _c('p', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.article.references)
	    }
	  })]), _vm._v(" "), (_vm.showAuthor) ? _c('h4', {
	    staticClass: "article-author"
	  }, [_c('i', [_vm._v(" " + _vm._s(_vm.article.author_name) + " " + _vm._s(_vm.article.author_surname))]), _c('br'), _c('br'), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "font-size": "12px"
	    }
	  }, [_vm._v(_vm._s(_vm.article.author_affiliation))])]) : _vm._e(), _vm._v(" "), (_vm.edition_id) ? _c('p', {
	    staticClass: "article-published"
	  }, [_vm._v("\n    Published in Series ... , Vol ... (ou special Edition Nr...), 2019\n  ")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('Article', {
	    attrs: {
	      "article": _vm.article,
	      "showAuthor": _vm.showAuthor,
	      "term": _vm.term
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-container"
	  }, [_c('div', {
	    staticClass: "form-register formResponsive"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Register")]), _c('br'), _c('br'), _vm._v(" "), _c('p', [_vm._v("Please register before submitting an article.")]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "inline"
	  }, [_vm._v("E-mail Address ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.register.email),
	      expression: "register.email"
	    }],
	    staticClass: "inline",
	    attrs: {
	      "type": "text",
	      "name": ""
	    },
	    domProps: {
	      "value": (_vm.register.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.register, "email", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "inline"
	  }, [_vm._v("Create a Password ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.register.password),
	      expression: "register.password"
	    }],
	    staticClass: "inline",
	    attrs: {
	      "type": "password",
	      "name": ""
	    },
	    domProps: {
	      "value": (_vm.register.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.register, "password", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("Your E-mail address and password will allow you to log in and view, edit or delete your submissions.\n        You will receive an e-mail with the confirmation of your registration and password. ")]), _c('br'), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "submit",
	      "value": "Register"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.validateRegister()
	      }
	    }
	  }), _c('br'), _c('br'), _vm._v(" "), _c('p', {
	    staticClass: "validation"
	  }, [_vm._v(" " + _vm._s(_vm.registerValidation) + " ")])])])
	},staticRenderFns: []}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form container"
	  }, [(!_vm.showForm) ? _c('div', [_c('Register', {
	    on: {
	      "showFormChanged": _vm.showFormChange
	    }
	  }), _vm._v(" "), _c('Login', {
	    on: {
	      "showFormChanged": _vm.showFormChange
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-article formResponsive formHorizontal"
	  }, [(!_vm.showForm) ? _c('div', {
	    staticClass: "formCover"
	  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item choose"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Choose or Propose an Entry")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Browse the lists below in order to choose an entry")]), _vm._v(" "), _c('div', [_c('span', {
	    staticClass: "inline tit2"
	  }, [_vm._v("Choose from all terms")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entry.id),
	      expression: "entry.id"
	    }],
	    staticClass: "inline",
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.entry, "id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        _vm.entry.english = '', _vm.entry.new = false, _vm.selectListLexical()
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "label": "Choose a Term"
	    }
	  }), _vm._v(" "), _c('optgroup', {
	    attrs: {
	      "label": "Epistemologies"
	    }
	  }, _vm._l((_vm.apiTerms), function(term) {
	    return (term.section_id === 1) ? _c('option', {
	      domProps: {
	        "value": term.id
	      }
	    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
	  }), 0), _vm._v(" "), _c('optgroup', {
	    attrs: {
	      "label": "History and Genealogy"
	    }
	  }, _vm._l((_vm.apiTerms), function(term) {
	    return (term.section_id === 2) ? _c('option', {
	      domProps: {
	        "value": term.id
	      }
	    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
	  }), 0), _vm._v(" "), _c('optgroup', {
	    attrs: {
	      "label": "Cultural Practices and Performativities"
	    }
	  }, _vm._l((_vm.apiTerms), function(term) {
	    return (term.section_id === 3) ? _c('option', {
	      domProps: {
	        "value": term.id
	      }
	    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
	  }), 0), _vm._v(" "), _c('optgroup', {
	    attrs: {
	      "label": "Linguistic Uses -  Terms"
	    }
	  }, _vm._l((_vm.apiTerms), function(term) {
	    return (term.section_id === 4) ? _c('option', {
	      domProps: {
	        "value": term.id
	      }
	    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
	  }), 0), _vm._v(" "), _c('optgroup', {
	    attrs: {
	      "label": "Linguistic Uses - Lexical Units"
	    }
	  }, _vm._l((_vm.apiLexicalUnits), function(term) {
	    return _c('option', {
	      domProps: {
	        "value": 'lu-' + term.id
	      }
	    }, [_vm._v(_vm._s(term.term_english))])
	  }), 0), _vm._v(" "), _c('optgroup', {
	    attrs: {
	      "label": "Arts, Literatures and imaginaries"
	    }
	  }, _vm._l((_vm.apiTerms), function(term) {
	    return (term.section_id === 5) ? _c('option', {
	      domProps: {
	        "value": term.id
	      }
	    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
	  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "tit2"
	  }, [_vm._v("or")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "tit2"
	  }, [_vm._v("Propose a New Entry")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "inline"
	  }, [_vm._v("in english")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entry.english),
	      expression: "entry.english"
	    }],
	    staticClass: "inline",
	    attrs: {
	      "type": "text",
	      "name": ""
	    },
	    domProps: {
	      "value": (_vm.entry.english)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.entry, "english", $event.target.value)
	      }, function($event) {
	        _vm.entry.id = '', _vm.entry.new = true
	      }]
	    }
	  })])]), _vm._v(" "), (_vm.entry.new) ? _c('div', {
	    staticClass: "form-article-item create",
	    staticStyle: {
	      "margin-top": "-40px"
	    }
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Thematic Sections")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Associate the New Entry to a Thematic Section.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "rsform-block",
	    staticStyle: {
	      "min-height": "100px"
	    }
	  }, [_c('div', {
	    staticClass: "formControls"
	  }, [_c('div', {
	    staticClass: "formBody"
	  }, [_c('div', {
	    staticClass: "rsformgrid6"
	  }, [_c('p', {
	    staticClass: "rsformVerticalClear"
	  }, [_c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "Periodohistorico20"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entry.section),
	      expression: "entry.section"
	    }],
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "radio",
	      "value": "1"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.entry.section, "1")
	    },
	    on: {
	      "input": function($event) {
	        _vm.entry.lexical = false
	      },
	      "change": function($event) {
	        return _vm.$set(_vm.entry, "section", "1")
	      }
	    }
	  }), _vm._v("\n                  Epistemologies\n                  "), _c('span', {
	    staticClass: "checkmark"
	  })])]), _vm._v(" "), _c('p', {
	    staticClass: "rsformVerticalClear"
	  }, [_c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "Periodohistorico20"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entry.section),
	      expression: "entry.section"
	    }],
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "radio",
	      "value": "2"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.entry.section, "2")
	    },
	    on: {
	      "input": function($event) {
	        _vm.entry.lexical = false
	      },
	      "change": function($event) {
	        return _vm.$set(_vm.entry, "section", "2")
	      }
	    }
	  }), _vm._v("\n                  History and Genealogy\n                  "), _c('span', {
	    staticClass: "checkmark"
	  })])]), _vm._v(" "), _c('p', {
	    staticClass: "rsformVerticalClear"
	  }, [_c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "Periodohistorico20"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entry.section),
	      expression: "entry.section"
	    }],
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "radio",
	      "value": "3"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.entry.section, "3")
	    },
	    on: {
	      "input": function($event) {
	        _vm.entry.lexical = false
	      },
	      "change": function($event) {
	        return _vm.$set(_vm.entry, "section", "3")
	      }
	    }
	  }), _vm._v("\n                  Cultural Practices\n                  "), _c('span', {
	    staticClass: "checkmark"
	  })])]), _vm._v(" "), _c('p', {
	    staticClass: "rsformVerticalClear"
	  }, [_c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "Periodohistorico20"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entry.section),
	      expression: "entry.section"
	    }],
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "radio",
	      "value": "4"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.entry.section, "4")
	    },
	    on: {
	      "input": function($event) {
	        _vm.entry.lexical = false
	      },
	      "change": function($event) {
	        return _vm.$set(_vm.entry, "section", "4")
	      }
	    }
	  }), _vm._v("\n                  Linguistic Uses\n                  "), _c('span', {
	    staticClass: "checkmark"
	  })])]), _vm._v(" "), _c('p', {
	    staticClass: "rsformVerticalClear"
	  }, [_c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "Periodohistorico20"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entry.section),
	      expression: "entry.section"
	    }],
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "radio",
	      "value": "5"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.entry.section, "5")
	    },
	    on: {
	      "input": function($event) {
	        _vm.entry.lexical = false
	      },
	      "change": function($event) {
	        return _vm.$set(_vm.entry, "section", "5")
	      }
	    }
	  }), _vm._v("\n                  Arts, Literatures and imaginaries\n                  "), _c('span', {
	    staticClass: "checkmark"
	  })])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.entry.section == '4') ? _c('div', {
	    staticClass: "rsform-block"
	  }, [_c('div', {
	    staticClass: "formControls"
	  }, [_c('div', {
	    staticClass: "formBody"
	  }, [_c('div', {
	    staticClass: "rsformgrid6"
	  }, [_c('p', {
	    staticClass: "rsformVerticalClear"
	  }, [_c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "Periodohistorico20"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entry.lexical),
	      expression: "entry.lexical"
	    }],
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "radio"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.entry.lexical, false)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.entry, "lexical", false)
	      }
	    }
	  }), _vm._v("\n                  Term\n                  "), _c('span', {
	    staticClass: "checkmark"
	  })])]), _vm._v(" "), _c('p', {
	    staticClass: "rsformVerticalClear"
	  }, [_c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "Periodohistorico20"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.entry.lexical),
	      expression: "entry.lexical"
	    }],
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "radio"
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.entry.lexical, true)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.entry, "lexical", true)
	      }
	    }
	  }), _vm._v("\n                  Lexical Unit\n                  "), _c('h5', [_vm._v("(word to be defined as loan word from another source language; only loans between African and European languages should be considered)")]), _vm._v(" "), _c('span', {
	    staticClass: "checkmark"
	  })])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.entry.lexical) ? _c('div', {
	    staticClass: "form-article-item article"
	  }, [_c('div', {
	    staticClass: "form-article-item"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Article")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.name_language),
	      expression: "article.name_language"
	    }],
	    attrs: {
	      "type": "text",
	      "name": ""
	    },
	    domProps: {
	      "value": (_vm.article.name_language)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.article, "name_language", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.title),
	      expression: "article.title"
	    }],
	    attrs: {
	      "type": "text",
	      "name": ""
	    },
	    domProps: {
	      "value": (_vm.article.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.article, "title", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("You may propose a title to your article in order to clarify the focus or approach to the Term/Entry. Max. 150 carat.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('wysiwyg', {
	    model: {
	      value: (_vm.article.body),
	      callback: function($$v) {
	        _vm.$set(_vm.article, "body", $$v)
	      },
	      expression: "article.body"
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3)], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Illustrations")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Optional (Maximum 1 image)")]), _vm._v(" "), _c('input', {
	    staticClass: "imageinput",
	    attrs: {
	      "type": "file"
	    },
	    on: {
	      "change": _vm.uploadImage
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Pictures (Photos, Drawings, etc). Allowed files: .jpg .png .gif")]), _vm._v(" "), (_vm.article.img_url) ? _c('div', {
	    staticClass: "image-consent"
	  }, [_c('label', {
	    staticClass: "container2 inline",
	    attrs: {
	      "for": "expressconsent0"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.img_auth),
	      expression: "article.img_auth"
	    }],
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "checkbox",
	      "value": "true"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.article.img_auth) ? _vm._i(_vm.article.img_auth, "true") > -1 : (_vm.article.img_auth)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.article.img_auth,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "true",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.article, "img_auth", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.article, "img_auth", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.article, "img_auth", $$c)
	        }
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "checkmark"
	  })]), _vm._v(" "), _c('p', {
	    staticClass: "inline"
	  }, [_vm._v("\n            The user declares that the submitted content has a Creative Commons License or is\n            covered by copyright to which they have a valid license.\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Keywords")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Please write your keywords in english (maximum 3).")]), _vm._v(" "), _c('div', {
	    staticClass: "rsform-block"
	  }, [_c('div', {
	    staticClass: "formControls"
	  }, [_c('div', {
	    staticClass: "formBody"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.keyword1),
	      expression: "article.keyword1"
	    }],
	    staticClass: "rsform-input-box",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "size": "20",
	      "placeholder": "1."
	    },
	    domProps: {
	      "value": (_vm.article.keyword1)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.article, "keyword1", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "formDescription"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "rsform-block"
	  }, [_c('div', {
	    staticClass: "formControls"
	  }, [_c('div', {
	    staticClass: "formBody"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.keyword2),
	      expression: "article.keyword2"
	    }],
	    staticClass: "rsform-input-box",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "size": "20",
	      "placeholder": "2."
	    },
	    domProps: {
	      "value": (_vm.article.keyword2)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.article, "keyword2", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "formDescription"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "rsform-block"
	  }, [_c('div', {
	    staticClass: "formControls"
	  }, [_c('div', {
	    staticClass: "formBody"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.keyword3),
	      expression: "article.keyword3"
	    }],
	    staticClass: "rsform-input-box",
	    attrs: {
	      "type": "text",
	      "value": "",
	      "size": "20",
	      "placeholder": "3."
	    },
	    domProps: {
	      "value": (_vm.article.keyword3)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.article, "keyword3", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('p', {
	    staticClass: "formDescription"
	  })])])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Hyperlinks")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Choose a maximum of 3 hyperlinks to other terms.")]), _vm._v(" "), _c('span', {
	    staticClass: "tit2"
	  }, [_vm._v("All Terms (A-Z)")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.currentLink),
	      expression: "article.currentLink"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.article, "currentLink", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "label": "Choose a Term"
	    }
	  }), _vm._v(" "), _c('optgroup', {
	    attrs: {
	      "label": "Epistemologies"
	    }
	  }, _vm._l((_vm.apiTerms), function(term) {
	    return (term.section_id === 1) ? _c('option', {
	      domProps: {
	        "value": term.id
	      }
	    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
	  }), 0), _vm._v(" "), _c('optgroup', {
	    attrs: {
	      "label": "History and Genealogy"
	    }
	  }, _vm._l((_vm.apiTerms), function(term) {
	    return (term.section_id === 2) ? _c('option', {
	      domProps: {
	        "value": term.id
	      }
	    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
	  }), 0), _vm._v(" "), _c('optgroup', {
	    attrs: {
	      "label": "Cultural Practices and Performativities"
	    }
	  }, _vm._l((_vm.apiTerms), function(term) {
	    return (term.section_id === 3) ? _c('option', {
	      domProps: {
	        "value": term.id
	      }
	    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
	  }), 0), _vm._v(" "), _c('optgroup', {
	    attrs: {
	      "label": "Linguistic Uses"
	    }
	  }, _vm._l((_vm.apiTerms), function(term) {
	    return (term.section_id === 4) ? _c('option', {
	      domProps: {
	        "value": term.id
	      }
	    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
	  }), 0), _vm._v(" "), _c('optgroup', {
	    attrs: {
	      "label": "Arts, Literatures and imaginaries"
	    }
	  }, _vm._l((_vm.apiTerms), function(term) {
	    return (term.section_id === 5) ? _c('option', {
	      domProps: {
	        "value": term.id
	      }
	    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
	  }), 0)]), _vm._v(" "), _c('button', {
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.addLink(_vm.article.currentLink)
	      }
	    }
	  }, [_vm._v("Add")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_vm._l((_vm.article.linkList), function(link) {
	    return _c('li', _vm._l((_vm.apiTerms), function(term) {
	      return (term.id === link) ? _c('span', [_vm._v("\n              " + _vm._s(term.term_english) + " -\n              "), _c('button', {
	        attrs: {
	          "type": "button"
	        },
	        on: {
	          "click": function($event) {
	            return _vm.removeLink(_vm.article.currentLink)
	          }
	        }
	      }, [_vm._v("Remove")])]) : _vm._e()
	    }), 0)
	  }), _vm._v(" "), (_vm.article.linkValidation) ? _c('p', [_vm._v("Maximum 3 Links")]) : _vm._e()], 2), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Bibliographic References")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('wysiwyg', {
	    model: {
	      value: (_vm.article.references),
	      callback: function($$v) {
	        _vm.$set(_vm.article, "references", $$v)
	      },
	      expression: "article.references"
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Include 3 to 5 bibliographic references within a maximum of 1000 characters (total).")]), _vm._v(" "), _c('p', [_vm._v("The references must follow the Publication Guidelines.")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Author")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "tit2"
	  }, [_vm._v("Name")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.author.surname),
	      expression: "article.author.surname"
	    }],
	    staticClass: "inline",
	    attrs: {
	      "type": "text",
	      "placeholder": "Surname"
	    },
	    domProps: {
	      "value": (_vm.article.author.surname)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.article.author, "surname", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.author.firstName),
	      expression: "article.author.firstName"
	    }],
	    staticClass: "inline",
	    attrs: {
	      "type": "text",
	      "placeholder": "First name and middle name"
	    },
	    domProps: {
	      "value": (_vm.article.author.firstName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.article.author, "firstName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "tit2"
	  }, [_vm._v("Affiliation and Funding Reference")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.author.affiliation),
	      expression: "article.author.affiliation"
	    }],
	    domProps: {
	      "value": (_vm.article.author.affiliation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.article.author, "affiliation", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Máx 300 carat.")]), _vm._v(" "), _c('p', [_vm._v("I agree that my e-mail be published with the signature of the article.")]), _vm._v(" "), _c('div', {
	    staticClass: "inline"
	  }, [_c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "expressconsent0"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.author.mail),
	      expression: "article.author.mail"
	    }],
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "radio"
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.article.author.mail, true)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.article.author, "mail", true)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "checkmark"
	  })]), _vm._v(" "), _c('p', [_vm._v("YES")])]), _vm._v(" "), _c('div', {
	    staticClass: "inline"
	  }, [_c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "expressconsent0"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.article.author.mail),
	      expression: "article.author.mail"
	    }],
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "radio"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.article.author.mail, false)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.article.author, "mail", false)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "checkmark"
	  })]), _vm._v(" "), _c('p', [_vm._v("NO")])])])]) : _vm._e(), _vm._v(" "), (_vm.entry.lexical) ? _c('div', {
	    staticClass: "form-article-item lexical"
	  }, [_c('div', [_c('div', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Languages")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
	    staticClass: "inline"
	  }, [_vm._v("Target Language")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.definition.lang_occu_id),
	      expression: "definition.lang_occu_id"
	    }],
	    staticClass: "inline",
	    staticStyle: {
	      "width": "80px !important"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.definition, "lang_occu_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        return _vm.langSelect('european')
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": "0"
	    }
	  }, [_vm._v("European")]), _vm._v(" "), _vm._l((_vm.apiLanguages), function(lang) {
	    return (lang.euro === 1) ? _c('option', {
	      domProps: {
	        "value": lang.id
	      }
	    }, [_vm._v(_vm._s(lang.name))]) : _vm._e()
	  })], 2), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.definition.lang_occu_id),
	      expression: "definition.lang_occu_id"
	    }],
	    staticClass: "inline",
	    staticStyle: {
	      "width": "80px !important"
	    },
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.definition, "lang_occu_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }, function($event) {
	        return _vm.langSelect('african')
	      }]
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": "0"
	    }
	  }, [_vm._v("African")]), _vm._v(" "), _vm._l((_vm.apiLanguages), function(lang) {
	    return (lang.afro === 1) ? _c('option', {
	      domProps: {
	        "value": lang.id
	      }
	    }, [_vm._v(_vm._s(lang.name))]) : _vm._e()
	  })], 2), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.definition.occurrence),
	      expression: "definition.occurrence"
	    }],
	    staticClass: "inline",
	    staticStyle: {
	      "width": "270px"
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "Write the lexical unit in the target language",
	      "name": ""
	    },
	    domProps: {
	      "value": (_vm.definition.occurrence)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.definition, "occurrence", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('div', [_c('label', {
	    staticClass: "inline"
	  }, [_vm._v("Source Language")]), _vm._v(" "), (_vm.definition.langOriginSelected && _vm.definition.langOriginSelected == 'african') ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.definition.lang_orig_id),
	      expression: "definition.lang_orig_id"
	    }],
	    staticClass: "inline",
	    staticStyle: {
	      "width": "80px !important"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.definition, "lang_orig_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": "0"
	    }
	  }, [_vm._v("European")]), _vm._v(" "), _vm._l((_vm.apiLanguages), function(lang) {
	    return (lang.euro === 1) ? _c('option', {
	      domProps: {
	        "value": lang.id
	      }
	    }, [_vm._v(_vm._s(lang.name))]) : _vm._e()
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.definition.langOriginSelected && _vm.definition.langOriginSelected == 'european') ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.definition.lang_orig_id),
	      expression: "definition.lang_orig_id"
	    }],
	    staticClass: "inline",
	    staticStyle: {
	      "width": "80px !important"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.definition, "lang_orig_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": "0"
	    }
	  }, [_vm._v("African")]), _vm._v(" "), _vm._l((_vm.apiLanguages), function(lang) {
	    return (lang.afro === 1) ? _c('option', {
	      domProps: {
	        "value": lang.id
	      }
	    }, [_vm._v(_vm._s(lang.name))]) : _vm._e()
	  })], 2) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.definition.origin),
	      expression: "definition.origin"
	    }],
	    staticClass: "inline",
	    staticStyle: {
	      "width": "270px"
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "Write the lexical unit in the language of origin",
	      "name": ""
	    },
	    domProps: {
	      "value": (_vm.definition.origin)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.definition, "origin", $event.target.value)
	      }
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item form-article-item-lexical"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Grammatical Category")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.definition.category),
	      expression: "definition.category"
	    }],
	    staticClass: "inline",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.definition, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "disabled": "",
	      "value": "0"
	    }
	  }, [_vm._v("Choose a Category")]), _vm._v(" "), _vm._l((_vm.apiGramCategories), function(cat) {
	    return _c('option', {
	      domProps: {
	        "value": cat.id
	      }
	    }, [_vm._v(_vm._s(cat.long_name))])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item form-article-item-lexical"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Definition")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('wysiwyg', {
	    model: {
	      value: (_vm.definition.meaning),
	      callback: function($$v) {
	        _vm.$set(_vm.definition, "meaning", $$v)
	      },
	      expression: "definition.meaning"
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Maximum of 1500 characters (total).")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item form-article-item-lexical"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Synonyms")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('wysiwyg', {
	    model: {
	      value: (_vm.definition.synonyms),
	      callback: function($$v) {
	        _vm.$set(_vm.definition, "synonyms", $$v)
	      },
	      expression: "definition.synonyms"
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Maximum of 100 characters (total).")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Notes")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('wysiwyg', {
	    model: {
	      value: (_vm.definition.notes),
	      callback: function($$v) {
	        _vm.$set(_vm.definition, "notes", $$v)
	      },
	      expression: "definition.notes"
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Maximum of 1500 characters (total). These notes will be published with the definition of the lexical unit")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Bibliographic References")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('wysiwyg', {
	    model: {
	      value: (_vm.definition.references),
	      callback: function($$v) {
	        _vm.$set(_vm.definition, "references", $$v)
	      },
	      expression: "definition.references"
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Include 3 to 5 bibliographic references within a maximum of 1000 characters (total).")]), _vm._v(" "), _c('p', [_vm._v("The references must follow the Publication Guidelines.")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Author")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "tit2"
	  }, [_vm._v("Name")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.definition.author.surname),
	      expression: "definition.author.surname"
	    }],
	    staticClass: "inline",
	    attrs: {
	      "type": "text",
	      "placeholder": "Surname"
	    },
	    domProps: {
	      "value": (_vm.definition.author.surname)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.definition.author, "surname", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.definition.author.firstName),
	      expression: "definition.author.firstName"
	    }],
	    staticClass: "inline",
	    attrs: {
	      "type": "text",
	      "placeholder": "First name and middle name"
	    },
	    domProps: {
	      "value": (_vm.definition.author.firstName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.definition.author, "firstName", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "tit2"
	  }, [_vm._v("Affiliation and Funding Reference")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.definition.author.affiliation),
	      expression: "definition.author.affiliation"
	    }],
	    domProps: {
	      "value": (_vm.definition.author.affiliation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.definition.author, "affiliation", $event.target.value)
	      }
	    }
	  }), _vm._v(" "), _c('p', [_vm._v("Máx 300 carat.")]), _vm._v(" "), _c('p', [_vm._v("I agree that my e-mail be published with the signature of the article.")]), _vm._v(" "), _c('div', {
	    staticClass: "inline"
	  }, [_c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "expressconsent0"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.definition.author.mail),
	      expression: "definition.author.mail"
	    }],
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "radio"
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.definition.author.mail, true)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.definition.author, "mail", true)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "checkmark"
	  })]), _vm._v(" "), _c('p', [_vm._v("YES")])]), _vm._v(" "), _c('div', {
	    staticClass: "inline"
	  }, [_c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "expressconsent0"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.definition.author.mail),
	      expression: "definition.author.mail"
	    }],
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "radio"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.definition.author.mail, false)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.definition.author, "mail", false)
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "checkmark"
	  })]), _vm._v(" "), _c('p', [_vm._v("NO")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "form-article-item outro"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Terms of Use & Copyright")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("I agree with the Terms of Use and Copyright of the Afro-European Cartography of Culture Language and Arts.")]), _vm._v(" "), _c('div', {
	    staticClass: "inline"
	  }, [_c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "expressconsent0"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.copyright),
	      expression: "copyright"
	    }],
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "checked": "",
	      "type": "radio"
	    },
	    domProps: {
	      "value": true,
	      "checked": _vm._q(_vm.copyright, true)
	    },
	    on: {
	      "change": function($event) {
	        _vm.copyright = true
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "checkmark"
	  })]), _vm._v(" "), _c('p', [_vm._v("YES")])]), _vm._v(" "), _c('div', {
	    staticClass: "inline"
	  }, [_c('label', {
	    staticClass: "container2",
	    attrs: {
	      "for": "expressconsent0"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.copyright),
	      expression: "copyright"
	    }],
	    staticClass: "rsform-checkbox",
	    attrs: {
	      "type": "radio"
	    },
	    domProps: {
	      "value": false,
	      "checked": _vm._q(_vm.copyright, false)
	    },
	    on: {
	      "change": function($event) {
	        _vm.copyright = false
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "checkmark"
	  })]), _vm._v(" "), _c('p', [_vm._v("NO")])])]), _vm._v(" "), _c('p', [_vm._v("For assistance with submitting your article please contact glossary@africaneuropeanarratives.eu")]), _vm._v(" "), _c('input', {
	    attrs: {
	      "value": "Submit",
	      "type": "submit",
	      "name": ""
	    },
	    on: {
	      "click": function($event) {
	        return _vm.validateEntry()
	      }
	    }
	  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
	    staticClass: "validation"
	  }, [_vm._v(_vm._s(_vm.validation))])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-article-item intro"
	  }, [_c('span', {
	    staticClass: "tit"
	  }, [_vm._v("Submit an Entry")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("to the African-European Cartography of Culture, Language and Arts")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n        We advise you to go through the whole form and read the Publication\n        Guidelines [\n        "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "/static/pdf/190619_glossario_Submissao&Normasdepublicacao_EN.pdf"
	    }
	  }, [_vm._v("pdf eng")]), _vm._v("\n        |\n        "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "/static/pdf/190502_glossario_Submissao&Normasdepublicacao.pdf"
	    }
	  }, [_vm._v("pdf pt")]), _vm._v(" ]\n        before starting the submission of your article.\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_vm._v("\n          Term\n          "), _c('p', [_vm._v("(In the language of your article)")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_vm._v("\n          Title\n          "), _c('p', [_vm._v("(optional)")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n          \"The article can have 6500 to 7000 characters long. Please check the Norms of Publication in the Submission Guidelines document [\n          "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "/static/pdf/190619_glossario_Submissao&Normasdepublicacao_EN.pdf"
	    }
	  }, [_vm._v("pdf eng")]), _vm._v("\n          |\n          "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "/static/pdf/190502_glossario_Submissao&Normasdepublicacao.pdf"
	    }
	  }, [_vm._v("pdf pt")]), _vm._v(" ] .\n          For quotations use H6 in the Headings menu.\n        ")])
	}]}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "choice"
	  }, [_c('span', {
	    staticClass: "choice-button tit",
	    class: {
	      inactive: !_vm.browse
	    },
	    on: {
	      "click": function($event) {
	        _vm.browse = true
	      }
	    }
	  }, [_vm._v("Browse")]), _vm._v(" "), _c('span', {
	    staticClass: "choice-button tit",
	    class: {
	      inactive: _vm.browse
	    },
	    on: {
	      "click": function($event) {
	        _vm.browse = false
	      }
	    }
	  }, [_vm._v("Info")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.browse) ? _c('div', [_c('div', {
	    staticClass: "browse"
	  }, [_c('div', {
	    staticClass: "browse-filters"
	  }, [_c('div', {
	    staticClass: "browse-filters-item",
	    class: {
	      active: _vm.topFilter === 'az'
	    },
	    on: {
	      "click": function($event) {
	        _vm.topFilter = 'az'
	      }
	    }
	  }, [_c('span', [_vm._v("A - Z")])]), _vm._v(" "), _c('div', {
	    staticClass: "browse-filters-item",
	    class: {
	      active: _vm.topFilter === 'thematic'
	    },
	    on: {
	      "click": function($event) {
	        _vm.topFilter = 'thematic'
	      }
	    }
	  }, [_c('span', [_vm._v("Thematic Sections")])]), _vm._v(" "), _c('div', {
	    staticClass: "browse-filters-item",
	    class: {
	      active: _vm.topFilter === 'authors'
	    },
	    on: {
	      "click": function($event) {
	        _vm.topFilter = 'authors'
	      }
	    }
	  }, [_c('span', [_vm._v("Authors")])]), _vm._v(" "), _c('div', {
	    staticClass: "browse-filters-item",
	    class: {
	      active: _vm.topFilter === 'search'
	    },
	    on: {
	      "click": function($event) {
	        _vm.topFilter = 'search'
	      }
	    }
	  }, [_vm._m(1)])]), _vm._v(" "), _c('div', {
	    staticClass: "browse-content"
	  }, [(_vm.topFilter === 'az') ? _c('div', [_c('div', {
	    staticClass: "browse-letters"
	  }, [_vm._l((_vm.alphabet), function(letter) {
	    return _c('span', {
	      class: {
	        active: _vm.azFilter === letter
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setAzFilter(letter)
	        }
	      }
	    }, [_vm._v(_vm._s(letter) + "\n            ")])
	  }), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('div', {
	    staticClass: "browse-blocks"
	  }, _vm._l((_vm.alphabet), function(letter) {
	    return _c('div', {
	      staticClass: "browse-blocks-item",
	      class: {
	        active: _vm.azFilter === letter
	      }
	    }, [_c('div', {
	      staticClass: "browse-blocks-title"
	    }, [_vm._v("\n                " + _vm._s(letter) + "\n              ")]), _vm._v(" "), _c('ul', _vm._l((_vm.filteredTerms(letter)), function(term) {
	      return _c('li', _vm._l((_vm.articleList), function(article) {
	        return (article.term_id === term.id) ? _c('router-link', {
	          attrs: {
	            "to": '/article/' + article.id
	          }
	        }, [_vm._v("\n                    " + _vm._s(term.term_english) + "\n                  ")]) : _vm._e()
	      }), 1)
	    }), 0)])
	  }), 0), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.topFilter === 'thematic') ? _c('div', [_c('div', {
	    staticClass: "browse-themes"
	  }, _vm._l((_vm.sectionList), function(section, index) {
	    return (index <= 4) ? _c('div', {
	      on: {
	        "click": function($event) {
	          _vm.themFilter = section.id
	        }
	      }
	    }, [_c('span', {
	      class: {
	        active: _vm.themFilter === section.id
	      }
	    }, [_vm._v("\n                " + _vm._s(section.long_name) + "\n              ")])]) : _vm._e()
	  }), 0), _vm._v(" "), _c('div', {
	    staticClass: "list-intro"
	  }, [(_vm.themFilter == 1) ? _c('p', [_c('span', {
	    staticClass: "lit"
	  }, [_vm._v("1. Epistemologies")]), _vm._v("\n              This thematic section will gather and evaluate the\n              theoretical-critical vocabulary that orients the investigation\n              of colonial and postcolonial contexts and, in particular, the\n              socio-cultural phenomena arising from them. The major fields of\n              research addressed in this section are: anthropology, sociology,\n              cultural theory and cultural studies, postcolonial studies,\n              linguistics, narratology, image theory and visual studies,\n              semiotics, among others.\n              "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.themFilter == 2) ? _c('p', [_c('span', {
	    staticClass: "lit"
	  }, [_vm._v("2. History and Genealogy")]), _vm._v("\n              This section will explore the historical context of colonialism,\n              with its unique set of tensions and conflicts that served as a\n              backdrop for the movements, wars, and phenomena that make up the\n              Afro-European relationship (colonies, decolonization, colonial\n              wars, anti-colonial struggles, imperialism, etc). The aim is to\n              reference the phenomena and the events while identifying the\n              processes and features that differentiate them. The role of this\n              section is to discuss heterogeneous and discontinuous phenomena\n              in order to map the relationships and tensions between them.\n              "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.themFilter == 3) ? _c('p', [_c('span', {
	    staticClass: "lit"
	  }, [_vm._v("3. Cultural Practices and Performativities")]), _vm._v("\n              This section addresses the cultural practices and the new forms\n              of performativity rooted in communities situated within the\n              Afro-European intercultural dialogue. The aim is to map out the\n              processes of the transubjectivation of identity - embodied in\n              habits, practices, customs, activist representations and claims\n              - of communities that are defined by this intercultural\n              experience. This section thus focus on cultural practices and\n              performativity as dynamic processes, imbued with contamination\n              and cultural hybridization and reflected in corporeality, in the\n              miscegenation of discourse, in the mixing of symbols, in new\n              representations and in the quest for identity.\n              "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.themFilter == 4) ? _c('p', [_c('span', {
	    staticClass: "lit"
	  }, [_vm._v("4. Linguistic Uses")]), _vm._v("\n              This section is subdivided into two glossaries: one of them\n              containing Terms, and the other one containing Lexical Units.\n              "), _c('br'), _vm._v("\n              The first glossary – Terms – presents the definition of\n              metalinguistic concepts specifically used in the Communication\n              and Language Sciences in order to enable a better understanding\n              of discursivities that take place between the African and\n              European continents and their intercultural dimension. This\n              intercultural dimension is the result of the contacts between\n              the various languages spoken in Africa and Europe and the\n              balance of power, which can be explained from a linguistic point\n              of view, but also from a sociological, anthropological,\n              political, and geographical point of view.\n              "), _c('br'), _vm._v("\n              The second glossary – Lexical Units – gathers vocabulary\n              resulting from the lexical contact and the loans into and from\n              languages spoken in Africa and Europe. We intend to collect\n              words that have deviations in meaning and form (neologisms),\n              registering the new uses that these units have gained both in\n              everyday language and figuratively, i.e., in poetic or literary\n              senses.\n              "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.themFilter == 5) ? _c('p', [_c('span', {
	    staticClass: "lit"
	  }, [_vm._v("5. Arts and Imaginaries")]), _vm._v("\n              This section deals with the colonial and postcolonial\n              imaginaries and with the creative practices that reflect or\n              deconstruct them (within and outside the institution of art) in\n              the fields of literature, film, visual arts, installation and\n              architecture, theatre and performance, music and dance. Its\n              purpose is to highlight the contribution made by literature and\n              artistic practices to the development of postcolonial thinking,\n              as well as the complex coexistence and relation between\n              modernism and the colonial contexts of the first half of the\n              twentieth century. In the face of the new cultural histories and\n              geographies stemming from globalization, as well as the\n              influential Western encoding of contemporary artistic culture,\n              the approach in this section will also examine what may come\n              after the creative and curatorial strategies of postcolonialism.\n            ")]) : _vm._e()]), _vm._v(" "), (_vm.themFilter !== 4) ? _c('div', [_c('div', {
	    staticClass: "browse-letters"
	  }, [_vm._l((_vm.alphabet), function(letter) {
	    return _c('span', {
	      class: {
	        active: _vm.azFilter === letter
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setAzFilter(letter)
	        }
	      }
	    }, [_vm._v(_vm._s(letter) + "\n              ")])
	  }), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('div', {
	    staticClass: "browse-blocks general"
	  }, _vm._l((_vm.alphabet), function(letter) {
	    return _c('div', {
	      staticClass: "browse-blocks-item",
	      class: {
	        active: _vm.azFilter === letter
	      }
	    }, [_c('div', {
	      staticClass: "browse-blocks-title"
	    }, [_vm._v("\n                  " + _vm._s(letter) + "\n                ")]), _vm._v(" "), _c('ul', _vm._l((_vm.filteredTerms(letter)), function(term) {
	      return (term.section_id == _vm.themFilter) ? _c('li', _vm._l((_vm.articleList), function(article) {
	        return (article.term_id === term.id) ? _c('router-link', {
	          attrs: {
	            "to": '/article/' + article.id
	          }
	        }, [_vm._v("\n                      " + _vm._s(term.term_english) + "\n                    ")]) : _vm._e()
	      }), 1) : _vm._e()
	    }), 0)])
	  }), 0), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.themFilter === 4) ? _c('div', {
	    staticClass: "browse-themes"
	  }, [_c('div', {
	    on: {
	      "click": function($event) {
	        _vm.subThemFilter = 'general'
	      }
	    }
	  }, [_c('span', {
	    class: {
	      active: _vm.subThemFilter === 'general'
	    }
	  }, [_vm._v("\n                Terms\n              ")])]), _vm._v(" "), _c('div', {
	    on: {
	      "click": function($event) {
	        _vm.subThemFilter = 'lexical'
	      }
	    }
	  }, [_c('span', {
	    class: {
	      active: _vm.subThemFilter === 'lexical'
	    }
	  }, [_vm._v("\n                Lexical Units\n              ")])])]) : _vm._e(), _vm._v(" "), (_vm.themFilter === 4 && _vm.subThemFilter === 'lexical') ? _c('div', {
	    staticClass: "lang-select"
	  }, [_c('div', {
	    staticClass: "lang-select-item"
	  }, [_c('label', [_vm._v("Target Language")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.langTarget),
	      expression: "langTarget"
	    }],
	    staticClass: "inline",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.langTarget = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("All languages")]), _vm._v(" "), _vm._l((_vm.apiLanguages), function(lang) {
	    return _c('option', {
	      domProps: {
	        "value": lang.id
	      }
	    }, [_vm._v("\n                  " + _vm._s(lang.name) + "\n                ")])
	  })], 2)]), _vm._v(" "), _c('div', {
	    staticClass: "lang-select-item"
	  }, [_c('label', [_vm._v("Source Language")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.langSource),
	      expression: "langSource"
	    }],
	    staticClass: "inline",
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.langSource = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "0"
	    }
	  }, [_vm._v("All languages")]), _vm._v(" "), _vm._l((_vm.apiLanguages), function(lang) {
	    return _c('option', {
	      domProps: {
	        "value": lang.id
	      }
	    }, [_vm._v("\n                  " + _vm._s(lang.name) + "\n                ")])
	  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.themFilter === 4) ? _c('div', {
	    staticClass: "browse-letters"
	  }, [_vm._l((_vm.alphabet), function(letter) {
	    return _c('span', {
	      class: {
	        active: _vm.themAzFilter === letter
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setThemAzFilter(letter)
	        }
	      }
	    }, [_vm._v(_vm._s(letter) + "\n            ")])
	  }), _vm._v(" "), _c('br')], 2) : _vm._e(), _vm._v(" "), (_vm.themFilter === 4 && _vm.subThemFilter === 'general') ? _c('div', {
	    staticClass: "browse-blocks lexic-term"
	  }, _vm._l((_vm.alphabet), function(letter) {
	    return _c('div', {
	      staticClass: "browse-blocks-item",
	      class: {
	        active: _vm.themAzFilter === letter
	      }
	    }, [_c('div', {
	      staticClass: "browse-blocks-title"
	    }, [_vm._v("\n                " + _vm._s(letter) + "\n              ")]), _vm._v(" "), _c('ul', _vm._l((_vm.filteredTerms(letter)), function(term) {
	      return (term.section_id == _vm.themFilter) ? _c('li', [_vm._l((_vm.articleList), function(article) {
	        return (article.term_id === term.id) ? _c('router-link', {
	          attrs: {
	            "to": '/article/' + article.id
	          }
	        }, [_vm._v("\n                    " + _vm._s(term.term_english) + " ")]) : _vm._e()
	      }), _c('br')], 2) : _vm._e()
	    }), 0)])
	  }), 0) : _vm._e(), _vm._v(" "), (_vm.themFilter === 4 && _vm.subThemFilter === 'lexical') ? _c('div', {
	    staticClass: "browse-blocks lexic-unit"
	  }, _vm._l((_vm.alphabet), function(letter) {
	    return _c('div', {
	      staticClass: "browse-blocks-item",
	      class: {
	        active: _vm.themAzFilter === letter
	      }
	    }, [_c('div', {
	      staticClass: "browse-blocks-title"
	    }, [_vm._v("\n                " + _vm._s(letter) + "\n              ")]), _vm._v(" "), _c('ul', _vm._l((_vm.filteredUnits(letter)), function(term) {
	      return (
	        (_vm.langTarget === '0' && _vm.langSource === '0') ||
	        (_vm.langTarget === term.lang_occu_id &&
	          _vm.langSource === term.lang_orig_id) ||
	        (_vm.langTarget === '0' &&
	          _vm.langSource === term.lang_orig_id) ||
	        (_vm.langTarget === term.lang_occu_id && _vm.langSource === '0')
	      ) ? _c('li', [_c('router-link', {
	        attrs: {
	          "to": '/lexical/' + term.id
	        }
	      }, [_vm._v("\n                    " + _vm._s(term.term_english) + " ")]), _c('br')], 1) : _vm._e()
	    }), 0)])
	  }), 0) : _vm._e(), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.topFilter === 'authors') ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "browse-blocks general browse-blocks-search"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.authorSearcher),
	      expression: "authorSearcher"
	    }],
	    staticClass: "search",
	    attrs: {
	      "placeholder": "Search author surname"
	    },
	    domProps: {
	      "value": (_vm.authorSearcher)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.authorSearcher = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "browse-blocks-item active"
	  }, [_c('div', {
	    staticClass: "browse-blocks-title"
	  }), _vm._v(" "), _c('ul', _vm._l((_vm.termList), function(term) {
	    return _c('li', _vm._l((_vm.articleList), function(article) {
	      return (
	        article.term_id === term.id &&
	        article.author_surname
	        .toLowerCase()
	        .includes(_vm.authorSearcher.toLowerCase()) &&
	        _vm.authorSearcher
	      ) ? _c('router-link', {
	        attrs: {
	          "to": '/article/' + article.id
	        }
	      }, [_vm._v("\n                    " + _vm._s(term.term_english) + " by " + _vm._s(article.author_name) + "\n                    " + _vm._s(article.author_surname) + "\n                  ")]) : _vm._e()
	    }), 1)
	  }), 0)])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.topFilter === 'search') ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "browse-blocks general browse-blocks-search"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searcher),
	      expression: "searcher"
	    }],
	    staticClass: "search",
	    attrs: {
	      "placeholder": "Search term or lexical unit"
	    },
	    domProps: {
	      "value": (_vm.searcher)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searcher = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "browse-blocks-item active"
	  }, [_c('div', {
	    staticClass: "browse-blocks-title"
	  }), _vm._v(" "), _c('ul', [_vm._l((_vm.termList), function(term) {
	    return (
	      term.term_english
	      .toLowerCase()
	      .includes(_vm.searcher.toLowerCase()) && _vm.searcher
	    ) ? _c('li', _vm._l((_vm.articleList), function(article) {
	      return (article.term_id === term.id) ? _c('router-link', {
	        attrs: {
	          "to": '/article/' + article.id
	        }
	      }, [_vm._v("\n                    " + _vm._s(term.term_english) + "\n                  ")]) : _vm._e()
	    }), 1) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.lexicalList), function(lexical) {
	    return (
	      lexical.term_english
	      .toLowerCase()
	      .includes(_vm.searcher.toLowerCase()) && _vm.searcher
	    ) ? _c('li', {
	      staticClass: "search-lexical"
	    }, [_c('router-link', {
	      attrs: {
	        "to": '/lexical/' + lexical.id
	      }
	    }, [_c('span', [_vm._v(_vm._s(lexical.term_english))])])], 1) : _vm._e()
	  })], 2)])]), _vm._v(" "), _c('br')]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (!_vm.browse) ? _c('div', [_vm._m(2)]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-intro"
	  }, [_c('div', {
	    staticClass: "list-intro-block"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/icon.png"
	    }
	  }), _vm._v(" "), _c('h1', [_vm._v("Afro-European Cartography of Culture, Language and Arts")]), _vm._v(" "), _c('i', [_vm._v("Glossary")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_vm._v("\n      The Afro-European Cartography of Culture, Language and Arts is a\n      research and publishing initiative of the project African-European\n      Narratives (started under Europe For Citizens Programme). Its goal is to\n      map the interplay between African and European cultures through various\n      perspectives (historical, epistemological, social, political, linguistic\n      and aesthetical) and to provide greater access to the scholarly\n      discussion on multicultural and post-colonial societies, as a relevant\n      dimension of knowledge citizenship.\n      "), _c('br'), _c('br'), _vm._v("\n      This cartography will evolve as progressive Glossary, a compilation of\n      terms and descriptions through the use of open and collaborative access\n      since stakeholders can either add new terms and descriptions or write\n      new articles for existing entries. Such openness will not preclude the\n      careful selection of terms and a methodological approach to the whole,\n      that will be ensured by a Scientific and Editorial Board and the\n      peer-review of submitted articles.\n    ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('img', {
	    attrs: {
	      "src": "/static/img/icons/search2.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "list-intro"
	  }, [_vm._v("\n      The terms and descriptions are grouped thematically, and not only then\n      alphabetically, so that fruitful links may be set up and encourage\n      intratextual readings. As a starting point, this Afro-European\n      Cartography invites research and writing to approach five main domains:\n      "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "lit"
	  }, [_vm._v("1. Epistemologies")]), _vm._v("\n      This thematic section will gather and evaluate the theoretical-critical\n      vocabulary that orients the investigation of colonial and postcolonial\n      contexts and, in particular, the socio-cultural phenomena arising from\n      them. The major fields of research addressed in this section are:\n      anthropology, sociology, cultural theory and cultural studies,\n      postcolonial studies, linguistics, narratology, image theory and visual\n      studies, semiotics, among others.\n      "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "lit"
	  }, [_vm._v("2. History and Genealogy")]), _vm._v("\n      This section will explore the historical context of colonialism, with\n      its unique set of tensions and conflicts that served as a backdrop for\n      the movements, wars, and phenomena that make up the Afro-European\n      relationship (colonies, decolonization, colonial wars, anti-colonial\n      struggles, imperialism, etc). The aim is to reference the phenomena and\n      the events while identifying the processes and features that\n      differentiate them. The role of this section is to discuss heterogeneous\n      and discontinuous phenomena in order to map the relationships and\n      tensions between them.\n      "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "lit"
	  }, [_vm._v("3. Cultural Practices and Performativities")]), _vm._v("\n      This section addresses the cultural practices and the new forms of\n      performativity rooted in communities situated within the Afro-European\n      intercultural dialogue. The aim is to map out the processes of the\n      transubjectivation of identity - embodied in habits, practices, customs,\n      activist representations and claims - of communities that are defined by\n      this intercultural experience. This section thus focus on cultural\n      practices and performativity as dynamic processes, imbued with\n      contamination and cultural hybridization and reflected in corporeality,\n      in the miscegenation of discourse, in the mixing of symbols, in new\n      representations and in the quest for identity.\n      "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "lit"
	  }, [_vm._v("4. Linguistic Uses")]), _vm._v("\n      The aim, in this section, is the gathering of a meta-language of\n      critical and analytical terms about language usage, as well as the\n      indexation of specific vocabulary derived from intercultural migrations\n      between African and European languages. The definition presented for\n      each of these lexical terms intends to account for its occurrences in a\n      target language and possible lexical and semantic transformations. The\n      section will set up a cartography of loans, linguistic contaminations in\n      both directions, from European languages to African languages and vice\n      versa. The interest is also to detect the deviations of meaning, new\n      usages, neologisms or adoption of terms that refer to migrations of\n      cultural practices, as well as a poetics of the language present, for\n      example, in literature. This collection also has a performative effect\n      on postcolonial epistemes in the sense that it provides us with a\n      dialogical perspective on cultures and a with linguistic ecology that\n      invites us to question the idea of indentitary monolinguism.\n      "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
	    staticClass: "lit"
	  }, [_vm._v("5. Arts and Imaginaries")]), _vm._v("\n      This section deals with the colonial and postcolonial imaginaries and\n      with the creative practices that reflect or deconstruct them (within and\n      outside the institution of art) in the fields of literature, film,\n      visual arts, installation and architecture, theatre and performance,\n      music and dance. Its purpose is to highlight the contribution made by\n      literature and artistic practices to the development of postcolonial\n      thinking, as well as the complex coexistence and relation between\n      modernism and the colonial contexts of the first half of the twentieth\n      century. In the face of the new cultural histories and geographies\n      stemming from globalization, as well as the influential Western encoding\n      of contemporary artistic culture, the approach in this section will also\n      examine what may come after the creative and curatorial strategies of\n      postcolonialism.\n      "), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Scientific Editorial Board")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n      Achille Mbembe (University of Johannesburg; Duke University, USA)\n      "), _c('br'), _vm._v("\n      Alain Kiyindou (Université Bordeaux-Montaigne, Chair UNESCO)\n      "), _c('br'), _vm._v("\n      Alexandra Magnólia Dias (NOVA University – IPRI)\n      "), _c('br'), _vm._v("\n      Ana Balona de Oliveira (NOVA University – IHA / Univeristy of Lisbon –\n      CEC)\n      "), _c('br'), _vm._v("\n      Ana Maria Martinho (NOVA University – CHAM)\n      "), _c('br'), _vm._v("\n      Ana Paula Tavares (University of Lisbon – CLEPUL)\n      "), _c('br'), _vm._v("\n      Angela Ferreira (Faculty of Beaux-Arts, Univ. of Lisbon – CIEBA)\n      "), _c('br'), _vm._v("\n      António Tomaz (University of Johannesburg)\n      "), _c('br'), _vm._v("\n      António Sousa Ribeiro (University of Coimbra – CES)\n      "), _c('br'), _vm._v("\n      Boaventura Sousa Santos (University of Coimbra – CES)\n      "), _c('br'), _vm._v("\n      Bonaventure Soh Bejeng Ndikung (Savvy Contemporary, Berlin)\n      "), _c('br'), _vm._v("\n      Elisio Macamo (University of Basel)\n      "), _c('br'), _vm._v("\n      Fernando Rosas (NOVA University – IHC)\n      "), _c('br'), _vm._v("\n      Iolanda Évora (ISEG - Center of Studies on Africa and Development)\n      "), _c('br'), _vm._v("\n      Inocência Mata (University of Lisbon – CEC)\n      "), _c('br'), _vm._v("\n      Manuela Ribeiro Sanches (University of Lisbon – CEC)\n      "), _c('br'), _vm._v("\n      Margarida Calafate Ribeiro (University of Coimbra – CES)\n      "), _c('br'), _vm._v("\n      Maria Paula Meneses (University of Coimbra – CES)\n      "), _c('br'), _vm._v("\n      Miguel Cardina (University of Coimbra – CES)\n      "), _c('br'), _vm._v("\n      Moisés Lemos Martins (Minho University - CECS\n      "), _c('br'), _vm._v("\n      Paula Nascimento (Curator, Beyond Entropy Africa)\n      "), _c('br'), _vm._v("\n      Paul Goodwin (University of the Arts, London)\n      "), _c('br'), _vm._v("\n      Paulo Inglês (University of Beyreuth and Polytechnic Institute Jean\n      Piaget, Benguela)\n      "), _c('br'), _vm._v("\n      Pedro Aires de Oliveira (NOVA University – IHC)\n      "), _c('br'), _vm._v("\n      Ricardo Roque (University of Lisbon – ICS)\n      "), _c('br'), _vm._v("\n      Ricardo Soares de Oliveira (Oxford University – St Peter’s College)\n      "), _c('br'), _vm._v("\n      Rute Costa (NOVA University of Lisbon – CLUNL)\n      "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Executive Editorial Board")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('i', [_vm._v("Coordinator")]), _vm._v(":\n      Maria Augusta Babo (NOVA University of Lisbon – ICNOVA)\n      "), _c('br'), _vm._v("\n      Cláudia Madeira (NOVA University of Lisbon – ICNOVA)\n      "), _c('br'), _vm._v("\n      Madalena Miranda (NOVA University of Lisbon – IHC)\n      "), _c('br'), _vm._v("\n      Maria Teresa Cruz (NOVA University of Lisbon – ICNOVA)\n      "), _c('br'), _vm._v("\n      Marta Lança (NOVA University of Lisbon – IHA)\n      "), _c('br'), _vm._v("\n      Pedro Aires de Oliveira (NOVA University of Lisbon – IHC)\n      "), _c('br'), _vm._v("\n      Rute Costa (NOVA University of Lisbon – CLUNL)\n      "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Webmaster")]), _vm._v(": \n      Inês Ponte (Lisbon University - ICS)\n      "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Invited Editors")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Web Design and Development")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "https://bagabagastudios.org/"
	    }
	  }, [_vm._v("Bagabaga Studios")]), _c('br'), _vm._v("\n      Ana Grave, Vasco Borges, Manuel Almeida\n      "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Editorial Information")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
	    staticClass: "small"
	  }, [_vm._v("Publishers")]), _vm._v(" "), _c('br'), _vm._v("\n      ICNOVA - Institute of Communication of NOVA Univeristy of Lisbon\n      (icnova.fcsh.unl.pt/)\n      "), _c('br'), _vm._v("\n      BUALA – Multidisciplinary Portal on Decolonization and Global South\n      Issues (buala.org)\n      "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
	    staticClass: "small"
	  }, [_vm._v("ISSN")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "http://africaneuropeanarratives.eu/en/terms-of-use-privacy-policy#terms-conditions"
	    }
	  }, [_c('b', {
	    staticClass: "small"
	  }, [_vm._v("Terms of Use & Privacy Policy ")])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Information for Authors")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
	    staticClass: "small"
	  }, [_vm._v("Publication Norms & Template ")]), _vm._v(" "), _c('br'), _vm._v("\n      ["), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "/static/pdf/subnormspdf_pt.pdf"
	    }
	  }, [_vm._v("PT")]), _vm._v("], ["), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "/static/pdf/subnormspdf_en.pdf"
	    }
	  }, [_vm._v("EN")]), _vm._v("]\n      "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
	    staticClass: "small"
	  }, [_vm._v("Special Calls")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
	    staticClass: "small"
	  }, [_vm._v("How to cite this Glossary ")]), _vm._v(" "), _c('br'), _vm._v("\n      Author's Surname, Name. Year. “Article Title or Term: Subtitle (in case\n      it exists).” In Afro-European Cartography of Culture, Language and Arts.\n      Lisbon: ICNOVA and BUALA. "), _c('br'), _vm._v("\n      URL: http://africaneuropeanarratives.eu/en/glossary\n      "), _c('br'), _c('br'), _vm._v(" "), _c('b', {
	    staticClass: "small"
	  }, [_vm._v("Contact")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
	    attrs: {
	      "target": "_blank",
	      "href": "mailto:glossary@africaneuropeanarratives.eu"
	    }
	  }, [_vm._v("glossary@africaneuropeanarratives.eu")])])
	}]}

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.3d48501e6c534f56428e.js